require("./index.css");
var $1i38n$reactjsxruntime = require("react/jsx-runtime");
var $1i38n$react = require("react");
var $1i38n$reactdom = require("react-dom");
var $1i38n$proptypes = require("prop-types");
var $1i38n$lodash = require("lodash");
var $1i38n$gramenesearchclient = require("gramene-search-client");
var $1i38n$gramenetreesclient = require("gramene-trees-client");
var $1i38n$reactbootstrap = require("react-bootstrap");
var $1i38n$reacticonsbs = require("react-icons/bs");
require("bootstrap/dist/css/bootstrap.min.css");
var $1i38n$platform = require("platform");
var $1i38n$interactjs = require("interact.js");
var $1i38n$d3scale = require("d3-scale");
var $1i38n$numeral = require("numeral");
var $1i38n$q = require("q");
var $1i38n$immutabilityhelper = require("immutability-helper");
var $1i38n$reactdnd = require("react-dnd");
var $1i38n$reactdndhtml5backend = require("react-dnd-html5-backend");
var $1i38n$lodashflow = require("lodash.flow");


      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d92d39518efdc8e9$export$2e2bcd8739ae039);











var $62e50bff44daad79$exports = {};

$parcel$defineInteropFlag($62e50bff44daad79$exports);

$parcel$export($62e50bff44daad79$exports, "default", () => $62e50bff44daad79$export$2e2bcd8739ae039);

var $62e50bff44daad79$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($1i38n$platform))).name === "IE" || (0, ($parcel$interopDefault($1i38n$platform))).name === "Microsoft Edge";








const $1acbe0e0655373a5$var$NodePopover = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                style: {
                    marginBottom: "0.5rem"
                },
                children: $1acbe0e0655373a5$var$buttons(props)
            }),
            $1acbe0e0655373a5$var$table(props)
        ]
    });
};
function $1acbe0e0655373a5$var$buttons(props) {
    return props.node.displayInfo.leafNode ? $1acbe0e0655373a5$var$geneNodeButtons(props) : $1acbe0e0655373a5$var$internalNodeButtons(props);
}
function $1acbe0e0655373a5$var$internalNodeButtons({ node: node, collapseClade: collapseClade, expandClade: expandClade }) {
    const collapseCladeButton = node.displayInfo.expanded ? $1acbe0e0655373a5$var$btn("Collapse", ()=>collapseClade(node, true), "warning") : undefined;
    // const collapseNodeButton = btn('Collapse node', () => collapseClade(node,false), "warning");
    const expandCladeButton = $1acbe0e0655373a5$var$btn("Expand", ()=>expandClade(node, true), "success");
    // const expandNodeButton = node.displayInfo.expanded ? undefined : btn('Expand node', () => expandClade(node,false), "success");
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
        children: [
            expandCladeButton,
            " ",
            collapseCladeButton
        ]
    });
}
function $1acbe0e0655373a5$var$geneNodeButtons({ node: node, changeParalogVisibility: changeParalogVisibility, changeGeneOfInterest: changeGeneOfInterest }) {
    var button;
    if (node.displayInfo.isGeneOfInterest && node.displayInfo.paralogs) {
        var root = node.parent;
        while(root.parent)root = root.parent;
        button = $1acbe0e0655373a5$var$btn("Show paralogs", ()=>changeParalogVisibility(root), "success");
    } else button = $1acbe0e0655373a5$var$btn("Focus on this gene", ()=>changeGeneOfInterest(node), "success");
    return button;
}
function $1acbe0e0655373a5$var$btn(name, handler, style = "default") {
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Button), {
        variant: style,
        onClick: handler,
        size: "sm",
        children: name
    });
}
function $1acbe0e0655373a5$var$table({ node: node, geneDocs: geneDocs }) {
    const model = node.model;
    const contents = node.displayInfo.leafNode ? $1acbe0e0655373a5$var$geneProps(model, geneDocs) : $1acbe0e0655373a5$var$internalProps(model);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Table), {
        hover: true,
        style: {
            fontSize: 12
        },
        children: contents
    });
}
function $1acbe0e0655373a5$var$geneProps(model, geneDocs) {
    const gene = geneDocs[model.gene_stable_id];
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
        children: [
            $1acbe0e0655373a5$var$prop("ID", model.gene_stable_id),
            $1acbe0e0655373a5$var$prop("Description", model.gene_description),
            $1acbe0e0655373a5$var$prop("nTranscripts", model.nTranscripts),
            $1acbe0e0655373a5$var$prop("Distance to parent", model.distance_to_parent.toPrecision(3)),
            gene && $1acbe0e0655373a5$var$prop("Location", `${gene.region}:${gene.start}-${gene.end}:${gene.strand === 1 ? "+" : "-"}`)
        ]
    });
}
function $1acbe0e0655373a5$var$internalProps(model) {
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
        children: [
            $1acbe0e0655373a5$var$prop("Bootstrap", model.bootstrap),
            model.duplication_confidence_score && $1acbe0e0655373a5$var$prop("Duplication confidence", 100 * model.duplication_confidence_score.toPrecision(3) + "%"),
            $1acbe0e0655373a5$var$prop("Distance to parent", model.distance_to_parent.toPrecision(3))
        ]
    });
}
function $1acbe0e0655373a5$var$prop(name, value) {
    if (!(0, ($parcel$interopDefault($1i38n$lodash))).isUndefined(value)) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                children: name
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                children: value
            })
        ]
    });
}
$1acbe0e0655373a5$var$NodePopover.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    geneDocs: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    collapseClade: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    expandClade: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    changeParalogVisibility: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired
};
var $1acbe0e0655373a5$export$2e2bcd8739ae039 = $1acbe0e0655373a5$var$NodePopover;








function $9250a846d2fdf47e$var$taxonomyColor(node) {
    let stats, colorScale, score;
    stats = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "relationToGeneOfInterest.taxonomy");
    if (stats) {
        score = stats.lcaDistance + stats.pathDistance;
        colorScale = stats.maxima.colorScale;
        return colorScale(score);
    }
}
var $9250a846d2fdf47e$export$2e2bcd8739ae039 = $9250a846d2fdf47e$var$taxonomyColor;






const $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE = 4;
const $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO = 0.8;
const $107ec56bdeb4af7c$var$Internal = (props)=>{
    const hasOneChild = props.node.children.length === 1;
    const xy = hasOneChild ? $107ec56bdeb4af7c$var$Internal.xy * $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO : $107ec56bdeb4af7c$var$Internal.xy;
    const wh = hasOneChild ? $107ec56bdeb4af7c$var$Internal.wh * $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO : $107ec56bdeb4af7c$var$Internal.wh;
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: $107ec56bdeb4af7c$var$className(props.node),
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                x: xy,
                y: xy,
                width: wh,
                height: wh
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
                x: "10",
                dy: ".35em",
                textAnchor: "start",
                children: $107ec56bdeb4af7c$var$text(props.node)
            })
        ]
    });
};
function $107ec56bdeb4af7c$var$className(node) {
    let className = "internal";
    let nodeType = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "model.node_type");
    if (nodeType) className += " " + nodeType;
    return className;
}
function $107ec56bdeb4af7c$var$text(node) {
    return (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "model.gene_display_label") || (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "model.gene_stable_id") || "";
}
$107ec56bdeb4af7c$var$Internal.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    onHover: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired
};
$107ec56bdeb4af7c$var$Internal.xy = $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE / -2;
$107ec56bdeb4af7c$var$Internal.wh = $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE;
var $107ec56bdeb4af7c$export$2e2bcd8739ae039 = $107ec56bdeb4af7c$var$Internal;


let $144e30bd197fcd40$var$defaultXAdjust = (0, $107ec56bdeb4af7c$export$2e2bcd8739ae039).xy;
// see CSS selector ".node:hover .internal"
const $144e30bd197fcd40$var$HOVER_SCALE_FACTOR = 2;
const $144e30bd197fcd40$var$Edge = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "edge",
        children: [
            $144e30bd197fcd40$var$interactionHelper(props),
            $144e30bd197fcd40$var$edge(props)
        ]
    });
};
function $144e30bd197fcd40$var$pathCoords(props) {
    let adjustedTarget, path;
    let source = props.source;
    let target = props.target;
    let shouldAdjust = props.cladeHovered && !props.thisCladeHovered;
    let yDoesntChange = (0, ($parcel$interopDefault($1i38n$lodash))).get(target, "model.children.length") === 1;
    // stop drawing the edge before it overlaps the parent node
    // (the child edge is always drawn after the parent node)
    let adjust = shouldAdjust ? $144e30bd197fcd40$var$defaultXAdjust * $144e30bd197fcd40$var$HOVER_SCALE_FACTOR : $144e30bd197fcd40$var$defaultXAdjust;
    if (yDoesntChange) {
        adjustedTarget = target.y - adjust;
        path = [
            [
                0,
                0
            ],
            [
                adjustedTarget - source.y,
                0
            ]
        ];
    } else {
        adjustedTarget = source.x > target.x ? target.x - adjust : target.x + adjust;
        path = [
            [
                0,
                0
            ],
            [
                target.y - source.y,
                0
            ],
            [
                target.y - source.y,
                adjustedTarget - source.x
            ]
        ];
    }
    return path;
}
function $144e30bd197fcd40$var$transform(c1, c2, size, isStyle) {
    let px, offset, transform, x1, x2, y1, y2, shouldScaleX;
    px = isStyle ? "px" : "";
    size = size || 1;
    offset = size / 2;
    x1 = c1[0];
    y1 = c1[1];
    x2 = c2[0];
    y2 = c2[1];
    shouldScaleX = x1 !== x2;
    // either the x coords (index 0) or y coords (index 1)
    // will differ.
    // if x coords differ, scaleX
    if (shouldScaleX) transform = "translate(" + (x2 - offset) + px + ", " + (y2 - offset) + px + ") " + "scale(" + (x1 - x2 + offset) + ", " + size + ") ";
    else transform = "translate(" + (x2 - offset) + px + ", " + y2 + px + ") " + "scale(" + size + ", " + (y1 - y2) + ")";
    return transform;
}
function $144e30bd197fcd40$var$rect(c1, c2, className, size, color) {
    // if either coordinate is missing, don't draw the rectangle.
    if (!c1 || !c2) return;
    let props = {
        className: className,
        style: {
            fill: color
        },
        x: 0,
        y: 0,
        width: 1,
        height: 1
    };
    if (0, $62e50bff44daad79$export$2e2bcd8739ae039) props.transform = $144e30bd197fcd40$var$transform(c1, c2, size, false);
    else props.style.transform = $144e30bd197fcd40$var$transform(c1, c2, size, true);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
        ...props
    });
}
function $144e30bd197fcd40$var$edge(props) {
    const coords = $144e30bd197fcd40$var$pathCoords(props);
    const className = "edge-rect";
    const size = props.cladeHovered ? $144e30bd197fcd40$var$Edge.width.hovered : $144e30bd197fcd40$var$Edge.width.edge;
    const color = (0, $9250a846d2fdf47e$export$2e2bcd8739ae039)(props.source);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            $144e30bd197fcd40$var$rect(coords[0], coords[1], className, size, color),
            $144e30bd197fcd40$var$rect(coords[1], coords[2], className, size, color)
        ]
    });
}
function $144e30bd197fcd40$var$interactionHelper(props) {
    const coords = $144e30bd197fcd40$var$pathCoords(props);
    const className = "interaction-rect";
    const size = $144e30bd197fcd40$var$Edge.width.helper;
    const color = (0, $9250a846d2fdf47e$export$2e2bcd8739ae039)(props.source);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "interaction-helper",
        children: [
            $144e30bd197fcd40$var$rect(coords[0], coords[1], className, size, color),
            $144e30bd197fcd40$var$rect(coords[1], coords[2], className, size, color)
        ]
    });
}
$144e30bd197fcd40$var$Edge.propTypes = {
    source: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    target: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    cladeHovered: (0, ($parcel$interopDefault($1i38n$proptypes))).bool.isRequired,
    thisCladeHovered: (0, ($parcel$interopDefault($1i38n$proptypes))).bool.isRequired
};
$144e30bd197fcd40$var$Edge.width = {
    edge: 1,
    hovered: 2,
    helper: 4
};
var $144e30bd197fcd40$export$2e2bcd8739ae039 = $144e30bd197fcd40$var$Edge;










const $68b624418d7ff7df$var$Collapsed = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "collapsed",
        children: [
            $68b624418d7ff7df$var$triangle(props.node),
            $68b624418d7ff7df$var$text(props.node)
        ]
    });
};
function $68b624418d7ff7df$var$text(node) {
    let texts, homologs, /*orthologs,*/ paralogs;
    homologs = node.leafNodes().length;
    //orthologs = _.get(node, 'displayInfo.orthologs.length') || 0;
    paralogs = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "displayInfo.paralogs.length") || 0;
    texts = [
        node.model.taxon_name + ": " + homologs + " genes"
    ];
    addToTexts(paralogs, "paralog");
    //addToTexts(orthologs, 'ortholog');
    function addToTexts(count, type) {
        let text, countText;
        if (count) {
            countText = count === homologs ? "all" : count;
            text = countText + " " + type;
            if (count > 1) text += "s";
            texts.push(text);
        }
    }
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
        x: "36",
        dy: ".35em",
        children: texts.join(", ")
    });
}
function $68b624418d7ff7df$var$style(node) {
    let color = (0, $9250a846d2fdf47e$export$2e2bcd8739ae039)(node);
    return {
        fill: color,
        stroke: color
    };
}
function $68b624418d7ff7df$var$triangle(node) {
    let d = "M0,0 30,8 30,-8 0,0";
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("path", {
        d: d,
        style: $68b624418d7ff7df$var$style(node)
    });
}
$68b624418d7ff7df$var$Collapsed.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    onHover: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired
};
var $68b624418d7ff7df$export$2e2bcd8739ae039 = $68b624418d7ff7df$var$Collapsed;







const $7b72a1e0c4f8653d$var$Gene = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: $7b72a1e0c4f8653d$var$className(props.node),
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("circle", {
                r: "3"
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
                x: "10",
                dy: ".35em",
                children: $7b72a1e0c4f8653d$var$text(props).join("; ")
            })
        ]
    });
};
function $7b72a1e0c4f8653d$var$className(node) {
    let className, homology, repType;
    className = "gene";
    homology = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "relationToGeneOfInterest.homology");
    repType = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "relationToGeneOfInterest.repType");
    if (homology) className += " homolog " + homology;
    if (repType) className += " representative";
    return className;
}
function $7b72a1e0c4f8653d$var$text(props) {
    return props.labelFields.map((field)=>{
        return (0, ($parcel$interopDefault($1i38n$lodash))).get(props.node, field);
    }); //'model.gene_stable_id');
}
$7b72a1e0c4f8653d$var$Gene.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    labelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    onHover: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    taxonomy: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired
};
var $7b72a1e0c4f8653d$export$2e2bcd8739ae039 = $7b72a1e0c4f8653d$var$Gene;


const $e66d18a0c723ce01$var$Node = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "node",
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                className: "interaction-helper",
                x: "-5",
                y: "-5",
                width: "10",
                height: "10"
            }),
            /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createElement($e66d18a0c723ce01$var$getNodeComponent(props.node), props)
        ]
    });
};
function $e66d18a0c723ce01$var$getNodeType(node) {
    if (node.model.gene_stable_id) return 0, $7b72a1e0c4f8653d$export$2e2bcd8739ae039;
    else if (!node.displayInfo.expanded) return 0, $68b624418d7ff7df$export$2e2bcd8739ae039;
    else return 0, $107ec56bdeb4af7c$export$2e2bcd8739ae039;
}
function $e66d18a0c723ce01$var$getNodeComponent(node) {
    return $e66d18a0c723ce01$var$getNodeType(node);
}
$e66d18a0c723ce01$var$Node.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    labelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    taxonomy: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired
};
var $e66d18a0c723ce01$export$2e2bcd8739ae039 = $e66d18a0c723ce01$var$Node;


class $27a8bd4ebb68f267$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.cladeRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createRef();
        this.state = {
            popoverVisible: false
        };
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    hover(e) {
        e.stopPropagation();
        this.props.onNodeHover(this.props.node);
        this.setState({
            hovered: true
        });
    }
    unhover(e) {
        e.stopPropagation();
        this.props.onNodeUnhover(this.props.node);
        this.setState({
            hovered: false
        });
    }
    togglePopoverVisibility() {
        this.setState({
            popoverVisible: !this.state.popoverVisible
        });
    }
    collapseClade(node, recurse) {
        this.setState({
            popoverVisible: false
        });
        this.props.collapseClade(node, recurse);
    }
    expandClade(node, recurse) {
        this.setState({
            popoverVisible: false
        });
        this.props.expandClade(node, recurse);
    }
    changeParalogVisibility(node) {
        this.setState({
            popoverVisible: false
        });
        this.props.changeParalogVisibility(node);
    }
    changeGeneOfInterest(node) {
        this.setState({
            popoverVisible: false
        });
        this.props.onGeneSelect(node);
    }
    transform(isStyle) {
        let px = isStyle ? "px" : "";
        let x, y;
        if (this.state.mounted) {
            x = this.props.node.x - this.props.xOffset;
            y = this.props.node.y - this.props.yOffset;
        } else {
            x = this.props.xOffset;
            y = this.props.yOffset;
        }
        return "translate(" + y + px + ", " + x + px + ")";
    }
    renderSubClades() {
        let node = this.props.node;
        let treeProps = (0, ($parcel$interopDefault($1i38n$lodash))).clone(this.props);
        let children = node.children;
        let cladeHovered = !!(this.props.cladeHovered || this.state.hovered);
        if ((0, ($parcel$interopDefault($1i38n$lodash))).isArray(children) && node.displayInfo.expanded) return children.map(function(childNode, idx) {
            treeProps.node = childNode;
            return /*#__PURE__*/ (0, $1i38n$react.createElement)($27a8bd4ebb68f267$export$2e2bcd8739ae039, {
                ...treeProps,
                key: idx,
                cladeHovered: cladeHovered,
                xOffset: node.x,
                yOffset: node.y
            });
        });
    }
    renderNode() {
        let node = this.props.node;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $e66d18a0c723ce01$export$2e2bcd8739ae039), {
            node: node,
            labelFields: this.props.labelFields,
            onHover: ()=>this.hover(),
            taxonomy: this.props.taxonomy
        });
    }
    renderEdge() {
        let node = this.props.node;
        let parent = node.parent;
        let cladeHovered = !!(this.props.cladeHovered || this.state.hovered);
        if (parent) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $144e30bd197fcd40$export$2e2bcd8739ae039), {
            source: node,
            target: parent,
            cladeHovered: cladeHovered,
            thisCladeHovered: !!this.state.hovered
        });
    }
    overlay(node, geneDocs) {
        const model = node.model;
        const titleText = model.node_type ? `${model.taxon_name} \u{2013} ${model.node_type}` : model.gene_display_label ? `${model.taxon_name} \u{2013} ${model.gene_display_label}` : `${model.taxon_name} - ${model.gene_stable_id}`;
        const id = `nodepopover${model.node_id}`;
        const title = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Button), {
                    className: "tooltip-title-button",
                    size: "sm",
                    variant: "light",
                    onClick: this.togglePopoverVisibility.bind(this),
                    children: "\xd7"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                    children: titleText
                })
            ]
        });
        return(// <Overlay show={this.state.popoverVisible}
        //          target={this.cladeRef.current}>
        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.Popover), {
            id: id,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Popover).Header, {
                    children: title
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Popover).Body, {
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1acbe0e0655373a5$export$2e2bcd8739ae039), {
                        node: node,
                        collapseClade: this.collapseClade.bind(this),
                        expandClade: this.expandClade.bind(this),
                        changeParalogVisibility: this.changeParalogVisibility.bind(this),
                        changeGeneOfInterest: this.changeGeneOfInterest.bind(this),
                        geneDocs: geneDocs
                    })
                })
            ]
        }));
    }
    cladeProps() {
        const props = {
            className: "clade"
        };
        if (0, $62e50bff44daad79$export$2e2bcd8739ae039) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return props;
    }
    render() {
        const popover = this.overlay(this.props.node, this.props.geneDocs);
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            ...this.cladeProps(),
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
                    trigger: "click",
                    placement: "right",
                    overlay: popover,
                    transition: false,
                    show: this.state.popoverVisible,
                    onToggle: this.togglePopoverVisibility.bind(this),
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
                        children: [
                            this.renderEdge(),
                            this.renderNode()
                        ]
                    })
                }),
                this.renderSubClades()
            ]
        });
    }
}
$27a8bd4ebb68f267$export$2e2bcd8739ae039.propTypes = {
    node: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    labelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    cladeHovered: (0, ($parcel$interopDefault($1i38n$proptypes))).bool,
    xOffset: (0, ($parcel$interopDefault($1i38n$proptypes))).number.isRequired,
    yOffset: (0, ($parcel$interopDefault($1i38n$proptypes))).number.isRequired,
    geneDocs: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired
};


const $42eda629c119b935$var$GeneTree = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
        className: "genetree",
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $27a8bd4ebb68f267$export$2e2bcd8739ae039), {
            ...props,
            node: props.nodes[0],
            xOffset: 0,
            yOffset: 0
        })
    });
};
$42eda629c119b935$var$GeneTree.propTypes = {
    nodes: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    labelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    onGeneSelect: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    onNodeHover: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    taxonomy: (0, ($parcel$interopDefault($1i38n$proptypes))).object
};
var $42eda629c119b935$export$2e2bcd8739ae039 = $42eda629c119b935$var$GeneTree;










var $2a90f6e2b76b788a$exports = {};

var $2a90f6e2b76b788a$var$alignments = {};
function $2a90f6e2b76b788a$var$calculateAlignmentFromConsensus(node) {
    var nodeId = node.model.node_id;
    if ($2a90f6e2b76b788a$var$alignments[nodeId]) return $2a90f6e2b76b788a$var$alignments[nodeId];
    // these blocks are likely to be smaller and more numerous
    let consensus = node.model.consensus;
    let deltaDepth = {};
    // find first non-zero frequency
    let i = 0;
    while(consensus.frequency[i] === 0)i++;
    deltaDepth[i] = consensus.frequency[i];
    let blocks = [];
    let block = {
        start: i,
        end: consensus.consensusLength
    };
    for(let j = i + 1; j < consensus.consensusLength; j++)if (consensus.frequency[j] !== consensus.frequency[i]) {
        deltaDepth[j] = consensus.frequency[j] - consensus.frequency[i];
        if (consensus.frequency[i] === 0) block.start = j;
        if (consensus.frequency[j] === 0) {
            block.end = j;
            blocks.push($1i38n$lodash.cloneDeep(block));
        }
        i = j;
    }
    if (consensus.frequency[i]) {
        deltaDepth[consensus.consensusLength] = 0 - consensus.frequency[i];
        block.end = consensus.consensusLength;
        blocks.push($1i38n$lodash.cloneDeep(block));
    }
    $2a90f6e2b76b788a$var$alignments[nodeId] = {
        hist: deltaDepth,
        blocks: blocks,
        size: consensus.consensusLength,
        nSeqs: consensus.nSeqs
    };
    return $2a90f6e2b76b788a$var$alignments[nodeId];
}
function $2a90f6e2b76b788a$var$getOffsets(positions) {
    return Object.keys(positions).map(function(i) {
        return +i;
    }).sort(function(a, b) {
        return a - b;
    });
}
function $2a90f6e2b76b788a$var$findGaps(alignment) {
    var positions = alignment.hist;
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var depth = 0;
    var gaps = [];
    var prevEnd = 0;
    for(var i = 0; i < offsets.length; i++){
        if (depth === 0 && prevEnd < offsets[i]) gaps.push({
            start: prevEnd,
            end: offsets[i]
        });
        depth += positions[offsets[i]];
        prevEnd = offsets[i];
    }
    if (prevEnd < alignment.size) gaps.push({
        start: prevEnd,
        end: alignment.size
    });
    return gaps;
}
function $2a90f6e2b76b788a$var$removeGapsFromAlignment(gaps, positions) {
    var collapsedSoFar = 0;
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var newPositions = {};
    var g = 0;
    offsets.forEach(function(offset) {
        while(g < gaps.length && offset > gaps[g].start){
            collapsedSoFar += gaps[g].end - gaps[g].start;
            g++;
        }
        var newOffset = offset - collapsedSoFar;
        if (newPositions[newOffset]) {
            newPositions[newOffset] += positions[offset];
            if (newPositions[newOffset] === 0) delete newPositions[newOffset];
        } else newPositions[newOffset] = positions[offset];
    });
    return newPositions;
}
function $2a90f6e2b76b788a$var$rebuildBlocksFromAlignment(positions) {
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var blocks = [];
    var depth = 0;
    for(var i = 0; i < offsets.length - 1; i++){
        depth += positions[offsets[i]];
        if (depth > 0) blocks.push({
            start: offsets[i],
            end: offsets[i + 1]
        });
    }
    return blocks;
}
function $2a90f6e2b76b788a$var$removeGaps(gaps, tree) {
    var size = $2a90f6e2b76b788a$var$alignments[tree.model.node_id].size;
    gaps.forEach(function(g) {
        size -= g.end - g.start;
    });
    tree.walk(function(node) {
        var nodeId = node.model.node_id;
        $2a90f6e2b76b788a$var$alignments[nodeId].size = size;
        $2a90f6e2b76b788a$var$alignments[nodeId].hist = $2a90f6e2b76b788a$var$removeGapsFromAlignment(gaps, $2a90f6e2b76b788a$var$alignments[nodeId].hist);
        if (!node.hasChildren()) $2a90f6e2b76b788a$var$alignments[nodeId].blocks = $2a90f6e2b76b788a$var$rebuildBlocksFromAlignment($2a90f6e2b76b788a$var$alignments[nodeId].hist);
    });
}
function $2a90f6e2b76b788a$var$mergeAdjacent(domainList) {
    let merged = [];
    let last = domainList.shift();
    domainList.forEach(function(d) {
        if (last.id === d.id && last.end === d.start) last.end = d.end;
        else {
            merged.push(last);
            last = d;
        }
    });
    merged.push(last);
    return merged;
}
function $2a90f6e2b76b788a$var$resolveOverlaps(dl) {
    if (dl.length < 2) return dl;
    let domainList = $1i38n$lodash.cloneDeep(dl);
    domainList.sort(function(a, b) {
        return a.start - b.start;
    });
    let trimmed = [];
    let last = $1i38n$lodash.clone(domainList[0]);
    let i = 1;
    while(i < domainList.length){
        var d = domainList[i];
        if (d.start >= last.end) {
            trimmed.push(last);
            last = d;
            i++;
        } else {
            // trim last up to d.start
            if (last.start < d.start) {
                let l = $1i38n$lodash.clone(last);
                l.end = d.start;
                trimmed.push(l);
                last.start = d.start;
            }
            if (d.nSeqs > last.nSeqs) {
                if (d.end >= last.end) {
                    last = d;
                    i++;
                } else {
                    // d ends inside of last but d is better
                    // need to trim last and insert it into domainList
                    // where it goes to preserve sorted order
                    let l = $1i38n$lodash.clone(last);
                    l.start = d.end;
                    last = $1i38n$lodash.clone(d);
                    let j = i + 1;
                    while(j < domainList.length && domainList[j].start < l.start){
                        domainList[j - 1] = domainList[j];
                        j++;
                    }
                    domainList[j - 1] = l;
                }
            } else if (last.end >= d.end) i++;
            else {
                let l = $1i38n$lodash.clone(d);
                l.start = last.end;
                let j = i + 1;
                while(j < domainList.length && domainList[j].start < l.start){
                    domainList[j - 1] = domainList[j];
                    j++;
                }
                domainList[j - 1] = l;
            }
        }
    }
    trimmed.push(last);
    return $2a90f6e2b76b788a$var$mergeAdjacent(trimmed);
}
$2a90f6e2b76b788a$exports = {
    calculateAlignment: $2a90f6e2b76b788a$var$calculateAlignmentFromConsensus,
    findGaps: $2a90f6e2b76b788a$var$findGaps,
    removeGaps: $2a90f6e2b76b788a$var$removeGaps,
    getOffsets: $2a90f6e2b76b788a$var$getOffsets,
    resolveOverlaps: $2a90f6e2b76b788a$var$resolveOverlaps,
    clean: function() {
        $2a90f6e2b76b788a$var$alignments = {};
    }
};


class $94496b6b5723afdf$var$Alignment extends (0, $1i38n$react.Component) {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.idRequired,
    //   highlight: React.PropTypes.string.isRequired,
    //   alignment: React.PropTypes.object.isRequred
    // }
    getColorMap(alignment, stats) {
        var regionColor = [];
        var grayScale = $1i38n$d3scale.scaleLinear().domain([
            0,
            alignment.nSeqs
        ]).range([
            "#DDDDDD",
            "#444444"
        ]);
        var prevEnd = 0;
        if (this.props.domains.length > 0) $2a90f6e2b76b788a$exports.resolveOverlaps(this.props.domains).forEach(function(d) {
            if (d.start > prevEnd) regionColor.push({
                start: prevEnd,
                end: d.start,
                color: grayScale
            });
            d.start;
            if (d.end > prevEnd) {
                prevEnd = d.end;
                var maxColor = stats[d.id].color;
                var colorScale = $1i38n$d3scale.scaleLinear().domain([
                    0,
                    1
                ]).range([
                    "#FFFFFF",
                    maxColor
                ]);
                regionColor.push({
                    start: d.start,
                    end: d.end,
                    color: $1i38n$d3scale.scaleLinear().domain([
                        0,
                        alignment.nSeqs
                    ]).range([
                        colorScale(0.5),
                        maxColor
                    ])
                });
            }
        });
        if (prevEnd < alignment.size) regionColor.push({
            start: prevEnd,
            end: alignment.size,
            color: grayScale
        });
        return regionColor;
    }
    renderHighlight() {
        if (this.props.highlight) {
            var hlStyle = {
                fill: this.props.highlight,
                stroke: false
            };
            var u = this.props.alignment.size / this.props.width;
            var w = 4 * u;
            var s = -w - u;
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                x: s,
                width: w,
                height: "18",
                style: hlStyle
            }, "highlight");
        }
    }
    render() {
        var alignment = $1i38n$lodash.cloneDeep(this.props.alignment);
        var regionColor = this.getColorMap(alignment, this.props.stats);
        var k = 0;
        var bins = [];
        var offsets = $2a90f6e2b76b788a$exports.getOffsets(alignment.hist);
        var depth = 0;
        var regionIdx = 0;
        var renderBlock = function(block) {
            var style = {
                fill: block.color,
                stroke: false
            };
            var s = block.start;
            var w = block.end - block.start;
            k++;
            var rect = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                width: w,
                height: "14",
                x: s,
                style: style
            }, k);
            return rect;
        };
        for(var i = 0; i < offsets.length - 1; i++){
            depth += alignment.hist[offsets[i]];
            if (depth > 0) {
                // find the region containing the start of this alignment block
                while(offsets[i] >= regionColor[regionIdx].end)regionIdx++;
                var color = regionColor[regionIdx].color(depth);
                // does the alignment block extend beyond the end of the region?
                if (offsets[i + 1] > regionColor[regionIdx].end) {
                    bins.push(renderBlock({
                        start: offsets[i],
                        end: regionColor[regionIdx].end,
                        color: color
                    }));
                    offsets[i] = regionColor[regionIdx].end;
                    if (!alignment.hist.hasOwnProperty(offsets[i])) alignment.hist[offsets[i]] = 0;
                    i--;
                } else bins.push(renderBlock({
                    start: offsets[i],
                    end: offsets[i + 1],
                    color: color
                }));
            }
        }
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            className: "alignment",
            children: [
                this.renderHighlight(),
                bins
            ]
        });
    }
}
var $94496b6b5723afdf$export$2e2bcd8739ae039 = $94496b6b5723afdf$var$Alignment;



class $7e36c170ebf80241$export$2e2bcd8739ae039 extends (0, $1i38n$react.Component) {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   highlight: React.PropTypes.string.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x; // - 7;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $94496b6b5723afdf$export$2e2bcd8739ae039), {
                width: this.props.width,
                node: this.props.node,
                highlight: this.props.highlight,
                stats: this.props.stats,
                domains: this.props.domains,
                alignment: this.props.alignment
            })
        });
    }
}











let $aed637ffd5f869a8$var$colors = $1i38n$d3scale.scaleOrdinal($1i38n$d3scale.schemeCategory10).range();
function $aed637ffd5f869a8$export$2e2bcd8739ae039(genetree) {
    const speciesNodes = genetree.leafNodes();
    const numGenes = speciesNodes.length;
    let colorIdx = 0;
    return speciesNodes.reduce((map, node)=>{
        const domains = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "model.domains");
        const geneId = (0, ($parcel$interopDefault($1i38n$lodash))).get(node, "model.gene_stable_id");
        if ((0, ($parcel$interopDefault($1i38n$lodash))).isArray(domains)) (0, ($parcel$interopDefault($1i38n$lodash))).forEach(domains, (domain)=>{
            const id = domain.id;
            let mapValue = map[id];
            if (!mapValue) map[id] = mapValue = {
                totalGenes: numGenes,
                genesWithDomain: 0,
                nodes: {},
                color: $aed637ffd5f869a8$var$colors[colorIdx++ % $aed637ffd5f869a8$var$colors.length]
            };
            if (!mapValue.nodes[geneId]) {
                mapValue.nodes[geneId] = node;
                mapValue.genesWithDomain++;
            }
        });
        return map;
    }, {});
}


class $eaf596603b94813f$var$Domains extends (0, $1i38n$react.Component) {
    constructor(props){
        super(props);
        this.cladeStats = (0, $aed637ffd5f869a8$export$2e2bcd8739ae039)(this.props.node);
    }
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    // componentDidUpdate() {
    //   if (this.props.node.hasChildren()) {
    //     this.cladeStats = domainStats(this.props.node);
    //   }
    // }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "domains",
            children: this.renderDomains()
        });
    }
    renderDomains() {
        let nonOverlappingDomains = (0, $2a90f6e2b76b788a$exports.resolveOverlaps)(this.props.domains);
        return nonOverlappingDomains.map((function(domain, idx) {
            var w = domain.end - domain.start + 1;
            var stats = this.props.stats[domain.id];
            var color = stats.color;
            var opacity = 0.1;
            var style = {
                fill: color,
                stroke: color,
                fillOpacity: opacity
            };
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
                trigger: [
                    "click",
                    "focus"
                ],
                rootClose: true,
                placement: "bottom",
                overlay: this.renderPopover(domain),
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                    width: w,
                    height: "18",
                    x: domain.start,
                    style: style
                })
            }, idx);
        }).bind(this));
    }
    renderPopover(domain) {
        var title = `${domain.id} - ${domain.name}`;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.Popover), {
            id: domain.name,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Popover).Header, {
                    children: title
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Popover).Body, {
                    children: this.renderPopoverContent(domain)
                })
            ]
        });
    }
    renderPopoverContent(domain) {
        if (this.props.node.isRoot()) return this.renderRootNodePopoverContent(domain);
        if (this.props.node.hasChildren()) return this.renderInternalNodePopoverContent(domain);
        else return this.renderGeneNodePopoverContent(domain);
    }
    renderRootNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var treeStatement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: treeStatement
                })
            ]
        });
    }
    renderInternalNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var cladeStats = this.cladeStats[domain.id];
        var treeStatement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        var cladeStatement = $eaf596603b94813f$var$createStatement(cladeStats, "clade");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: treeStatement
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: cladeStatement
                })
            ]
        });
    }
    renderGeneNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var statement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: statement
                })
            ]
        });
    }
}
function $eaf596603b94813f$var$createStatement(stats, whatIsThis) {
    var geneCount = stats.genesWithDomain;
    var totalGenes = stats.totalGenes;
    var proportion = (0, ($parcel$interopDefault($1i38n$numeral)))(geneCount / totalGenes).format("0.0%");
    var statement;
    if (geneCount === totalGenes) statement = `Shared by all ${totalGenes} genes in this ${whatIsThis}.`;
    else if (geneCount === 1) statement = `There is only one gene in the ${whatIsThis} with this domain.`;
    else statement = `Shared by ${geneCount} of ${totalGenes} (${proportion}) genes in this ${whatIsThis}.`;
    return statement;
}
var $eaf596603b94813f$export$2e2bcd8739ae039 = $eaf596603b94813f$var$Domains;



class $5e8e312d635014fa$var$PositionedDomains extends (0, $1i38n$react.Component) {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $eaf596603b94813f$export$2e2bcd8739ae039), {
                stats: this.props.stats,
                width: this.props.width,
                node: this.props.node,
                domains: this.props.domains
            })
        });
    }
}
var $5e8e312d635014fa$export$2e2bcd8739ae039 = $5e8e312d635014fa$var$PositionedDomains;






function $e4b494008561eb2b$var$remap(seqPos, blocks) {
    var posInSeq = 0;
    for(var b = 0; b < blocks.length; b++){
        var block = blocks[b];
        var blockLength = block.end - block.start + 1;
        if (seqPos <= posInSeq + blockLength) return block.start + (seqPos - posInSeq);
        posInSeq += blockLength;
    }
    return 0;
}
class $e4b494008561eb2b$export$2e2bcd8739ae039 extends (0, $1i38n$react.Component) {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    render() {
        var node = this.props.node;
        var alignment = this.props.alignment;
        var k = 0;
        var bins = node.model.exon_junctions.map(function(ej) {
            var ejPos = $e4b494008561eb2b$var$remap(ej, alignment.blocks);
            var top = ejPos - 1;
            var style = {
                fill: "red",
                stroke: false
            };
            k++;
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                width: "1",
                height: "18",
                x: top,
                style: style
            }, k);
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "exonJunctions",
            children: bins
        });
    }
}



class $ce710bd567690513$export$2e2bcd8739ae039 extends (0, $1i38n$react.Component) {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    //
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $e4b494008561eb2b$export$2e2bcd8739ae039), {
                width: this.props.width,
                node: this.props.node,
                alignment: this.props.alignment
            })
        });
    }
}





var $5ac4cd4b588bde41$var$domains = {};
function $5ac4cd4b588bde41$var$remap(seqPos, blocks) {
    var posInSeq = 0;
    for(var b = 0; b < blocks.length; b++){
        var block = blocks[b];
        var blockLength = block.end - block.start;
        if (seqPos <= posInSeq + blockLength) return block.start + (seqPos - posInSeq);
        posInSeq += blockLength;
    }
    return 0;
}
function $5ac4cd4b588bde41$var$mergeDomains(domainList) {
    // merge domains with the same id first
    // then merge with other domains
    var domainHist = {}; // key is domain id
    domainList.forEach(function(d) {
        if (!domainHist.hasOwnProperty(d.id)) {
            domainHist[d.id] = $1i38n$lodash.clone(d); // representative
            domainHist[d.id].hist = {};
        }
        var hist = domainHist[d.id].hist;
        if (hist[d.start]) hist[d.start] += d.nSeqs;
        else hist[d.start] = d.nSeqs;
        if (hist[d.end]) hist[d.end] -= d.nSeqs;
        else hist[d.end] = -d.nSeqs;
    });
    var merged = [];
    $1i38n$lodash.each(domainHist, function(domain) {
        var offsets = (0, $2a90f6e2b76b788a$exports.getOffsets)(domain.hist);
        var depth = 0;
        for(var i = 0; i < offsets.length - 1; i++){
            depth += domain.hist[offsets[i]];
            if (depth > 0) {
                var d = $1i38n$lodash.clone(domain);
                d.start = offsets[i];
                d.end = offsets[i + 1];
                d.nSeqs = depth;
                delete d.hist;
                merged.push(d);
            }
        }
    });
    return merged;
}
function $5ac4cd4b588bde41$export$2e2bcd8739ae039(node, reset) {
    if (reset) $5ac4cd4b588bde41$var$domains = {};
    var nodeId = node.model.node_id;
    if ($5ac4cd4b588bde41$var$domains[nodeId]) return $5ac4cd4b588bde41$var$domains[nodeId];
    if (node.model.cigar) {
        var alignment = (0, $2a90f6e2b76b788a$exports.calculateAlignment)(node);
        if (node.model.domains) {
            // map start and end positions in domains to positions in cigar space
            var domainsList = node.model.domains.map(function(d) {
                return {
                    start: $5ac4cd4b588bde41$var$remap(d.start - 1, alignment.blocks),
                    end: $5ac4cd4b588bde41$var$remap(d.end, alignment.blocks),
                    root: d.root,
                    id: d.id,
                    name: d.name,
                    description: d.description,
                    nSeqs: 1
                };
            });
            $5ac4cd4b588bde41$var$domains[nodeId] = domainsList;
        } else // no domains on this gene, return an empty list
        $5ac4cd4b588bde41$var$domains[nodeId] = [];
    } else if (node.children.length === 1) $5ac4cd4b588bde41$var$domains[nodeId] = $5ac4cd4b588bde41$export$2e2bcd8739ae039(node.children[0]);
    else {
        var domainList = [];
        node.children.forEach(function(childNode) {
            var childDomains = $5ac4cd4b588bde41$export$2e2bcd8739ae039(childNode);
            childDomains.forEach(function(cd) {
                domainList.push(cd);
            });
        });
        // if we have domains, merge them
        if (domainList.length > 1) domainList = $5ac4cd4b588bde41$var$mergeDomains(domainList);
        $5ac4cd4b588bde41$var$domains[nodeId] = domainList;
    }
    return $5ac4cd4b588bde41$var$domains[nodeId];
}




class $2dbe1a8664116125$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {};
        this.zoomerRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createRef();
        this.svgRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createRef();
        this.consensusLength = props.rootNode.model.consensus.sequence.length;
        this.charWidth = 7.2065;
        this.minWidth = props.width * props.width / (this.charWidth * this.consensusLength);
        this.MSARange = props.MSARange;
    }
    componentDidMount() {
        let zoomer = this.zoomerRef.current;
        if (zoomer) {
            let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
            let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
            zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
            zoomer.style.width = this.props.width * (this.MSARange.MSAStop - this.MSARange.MSAStart) / this.consensusLength + "px";
            (0, ($parcel$interopDefault($1i38n$interactjs)))(zoomer).draggable({
                onmove: this.dragMoveListener.bind(this)
            }).resizable({
                preserveAspectRatio: false,
                edges: {
                    left: true,
                    right: true,
                    bottom: false,
                    top: false
                }
            }).on("resizemove", (function(event) {
                if (event.rect.width > this.minWidth) {
                    let target = event.target;
                    let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
                    let y = parseFloat(target.getAttribute("data-y")) || 0;
                    if (event.deltaRect.left !== 0) {
                        // move left edge
                        x += event.deltaRect.left;
                        if (x < 0) x = 0;
                        this.MSARange.MSAStart = x * this.consensusLength / this.props.width;
                    }
                    if (event.deltaRect.right !== 0) {
                        // move right edge
                        let right = x + event.rect.width;
                        if (right > this.props.width) right = this.props.width;
                        this.MSARange.MSAStop = right * this.consensusLength / this.props.width;
                    }
                    let viewWidth = this.MSARange.MSAStop - this.MSARange.MSAStart;
                    target.style.width = this.props.width * viewWidth / this.consensusLength + "px";
                    target.style.webkitTransform = target.style.transform = `translate(${x}px,${y}px)`;
                    target.setAttribute("data-x", x);
                    // let vb = `${this.MSARange.MSAStart} -3 ${viewWidth} ${this.props.height}`;
                    this.svgRef.current.setAttribute("viewBox", this.getViewBox(false));
                    this.props.handleRangeChange(this.MSARange);
                }
            }).bind(this));
        }
    }
    componentDidUpdate() {
        let zoomer = this.zoomerRef.current;
        let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
        let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
        zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
        zoomer.style.width = this.props.width * (this.MSARange.MSAStop - this.MSARange.MSAStart) / this.consensusLength + "px";
    }
    dragMoveListener(event) {
        if (this.MSARange.MSAStop - this.MSARange.MSAStart < 0.98 * this.consensusLength) {
            let target = event.target, x = this.props.width * this.MSARange.MSAStart / this.consensusLength + event.dx, y = parseFloat(target.getAttribute("data-y")) || 0;
            // respect boundaries
            if (x < 0) x = 0;
            let zoomerWidth = parseFloat(target.style.width);
            if (x + zoomerWidth > this.props.width) x = this.props.width - zoomerWidth;
            let xPosInSeq = this.consensusLength * x / this.props.width;
            let viewWidth = this.MSARange.MSAStop - this.MSARange.MSAStart;
            // if (xPosInSeq + viewWidth > this.consensusLength) {
            //   viewWidth = this.consensusLength - xPosInSeq;
            // }
            // translate the element
            target.style.webkitTransform = target.style.transform = "translate(" + x + "px, " + y + "px)";
            // update the position attribute
            target.setAttribute("data-x", x);
            // update the MSA position
            this.MSARange.MSAStart = xPosInSeq;
            this.MSARange.MSAStop = xPosInSeq + viewWidth;
            // let vb = `${xPosInSeq} -3 ${viewWidth} ${this.props.height}`;
            this.svgRef.current.setAttribute("viewBox", this.getViewBox(false));
            this.props.handleRangeChange(this.MSARange);
        }
    }
    getViewBox(forConsensus) {
        let viewBoxMinX = forConsensus ? 0 : this.MSARange.MSAStart;
        let viewBoxMinY = -3;
        let viewBoxWidth = forConsensus ? this.consensusLength : this.MSARange.MSAStop - this.MSARange.MSAStart;
        let viewBoxHeight = forConsensus ? this.props.controlsHeight : this.props.height + 2 * this.props.margin + 3;
        return `${viewBoxMinX} ${viewBoxMinY} ${viewBoxWidth} ${viewBoxHeight}`;
    }
    renderNode(node) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let alignment = (0, (/*@__PURE__*/$parcel$interopDefault($2a90f6e2b76b788a$exports))).calculateAlignment(node);
            let pej;
            if (node.model.exon_junctions) pej = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $ce710bd567690513$export$2e2bcd8739ae039), {
                node: node,
                width: this.props.width,
                alignment: alignment
            });
            let domains = (0, $5ac4cd4b588bde41$export$2e2bcd8739ae039)(node);
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
                children: [
                    pej,
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $7e36c170ebf80241$export$2e2bcd8739ae039), {
                        node: node,
                        width: this.props.width,
                        stats: this.props.stats,
                        domains: domains,
                        highlight: false,
                        alignment: alignment
                    }),
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $5e8e312d635014fa$export$2e2bcd8739ae039), {
                        node: node,
                        width: this.props.width,
                        stats: this.props.stats,
                        alignment: alignment,
                        domains: domains
                    })
                ]
            }, node.model.node_id);
        }
    }
    renderControls() {
        const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Tooltip), {
            id: "tooltip",
            children: "resize and drag"
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                    className: "consensus-wrapper",
                    transform: `translate(${this.props.xOffset},3)`,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                        width: this.props.width,
                        height: this.props.controlsHeight,
                        viewBox: this.getViewBox(true),
                        preserveAspectRatio: "none",
                        children: this.renderNode(this.props.rootNode)
                    })
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
                    x: this.props.xOffset,
                    y: this.props.yOffset,
                    width: this.props.width,
                    height: this.props.controlsHeight + 6,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
                        placement: "left",
                        overlay: tooltip,
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                            className: "resize-container",
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                                ref: this.zoomerRef,
                                className: "resize-drag",
                                style: {
                                    height: this.props.controlsHeight + 6
                                }
                            })
                        })
                    })
                })
            ]
        });
    }
    renderOverview() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "alignments-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset + this.props.controlsHeight + this.props.margin - 10})`,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                ref: this.svgRef,
                width: this.props.width,
                height: this.props.height + 2 * this.props.margin,
                viewBox: this.getViewBox(false),
                preserveAspectRatio: "none",
                children: this.props.nodes.map(this.renderNode.bind(this))
            })
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                this.renderOverview(),
                this.renderControls()
            ]
        });
    }
}









class $3a89ac38d37e6c49$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {};
        this.zoomerRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createRef();
        this.consensusLength = this.props.rootNode.model.consensus.sequence.length;
        this.charWidth = 7.2065;
        this.charsAtOnce = props.width / this.charWidth;
        this.windowWidth = props.width * props.width / (this.charWidth * this.consensusLength);
        this.MSARange = props.MSARange;
    }
    // componentWillMount() {
    // }
    dragMoveListener(event) {
        let target = event.target, x = this.props.width * this.MSARange.MSAStart / this.consensusLength + event.dx, y = parseFloat(target.getAttribute("data-y")) || 0;
        // respect boundaries
        if (x < 0) x = 0;
        if (x > this.props.width - this.windowWidth) x = this.props.width - this.windowWidth;
        // translate the element
        target.style.webkitTransform = target.style.transform = "translate(" + x + "px, " + y + "px)";
        // update the position attribute
        target.setAttribute("data-x", x);
        // update the MSA position
        let Xmin = x * this.consensusLength / this.props.width;
        let rows = document.getElementsByClassName("MSAlignments-wrapper");
        rows[0].scrollLeft = Xmin * this.charWidth;
        this.MSARange.MSAStart = Xmin;
        this.MSARange.MSAStop = Xmin + this.charsAtOnce;
        this.props.handleRangeChange(this.MSARange);
    }
    componentDidMount() {
        let zoomer = this.zoomerRef.current;
        if (zoomer) {
            let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
            let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
            zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
            zoomer.style.width = this.windowWidth + "px";
            let rows = document.getElementsByClassName("MSAlignments-wrapper");
            rows[0].scrollLeft = this.MSARange.MSAStart * this.charWidth;
            (0, ($parcel$interopDefault($1i38n$interactjs)))(zoomer).draggable({
                onmove: this.dragMoveListener.bind(this)
            });
        }
    }
    componentDidUpdate() {
        let zoomer = this.zoomerRef.current;
        this.windowWidth = this.props.width * this.props.width / (this.charWidth * this.consensusLength);
        this.charsAtOnce = this.props.width / this.charWidth;
        let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
        let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
        zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
        let rows = document.getElementsByClassName("MSAlignments-wrapper");
        rows[0].scrollLeft = this.MSARange.MSAStart * this.charWidth;
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.colorScheme !== this.props.colorScheme) {
            // change the className - don't render again CSS will do the work
            let rows = document.getElementsByClassName(this.props.colorScheme);
            while(rows.length > 0)rows[0].className = nextProps.colorScheme;
            return false;
        }
        return true;
    }
    getViewBox() {
        let viewBoxMinX = 0;
        let viewBoxMinY = -3;
        let viewBoxWidth = this.consensusLength;
        let viewBoxHeight = this.props.controlsHeight;
        return `${viewBoxMinX} ${viewBoxMinY} ${viewBoxWidth} ${viewBoxHeight}`;
    }
    renderNode(node) {
        let alignment = (0, (/*@__PURE__*/$parcel$interopDefault($2a90f6e2b76b788a$exports))).calculateAlignment(node);
        let domains = (0, $5ac4cd4b588bde41$export$2e2bcd8739ae039)(node);
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $7e36c170ebf80241$export$2e2bcd8739ae039), {
                    node: node,
                    width: this.props.width,
                    stats: this.props.stats,
                    domains: domains,
                    highlight: false,
                    alignment: alignment
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $5e8e312d635014fa$export$2e2bcd8739ae039), {
                    node: node,
                    width: this.props.width,
                    stats: this.props.stats,
                    domains: domains,
                    alignment: alignment
                })
            ]
        }, node.model.node_id);
    }
    renderSequence(node) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let MSAProps = {
                key: node.model.node_id,
                className: this.props.colorScheme
            };
            let seq = node.model.consensus.sequence;
            let spans = []; // hold the lengths of each run
            let spanStart = 0;
            for(let i = 1; i < seq.length; i++)if (seq[i] !== seq[spanStart]) {
                spans.push(i - spanStart);
                spanStart = i;
            }
            spans.push(seq.length - spanStart);
            let offset = 0;
            let gapCode = "-".charCodeAt(0);
            let msaRow = [];
            for(let i = 0; i < spans.length; i++){
                let bases = String.fromCharCode.apply(this, seq.slice(offset, offset + spans[i]));
                let className = seq[offset] === gapCode ? "gap" : bases.charAt(0);
                msaRow.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                    className: className,
                    children: bases
                }, i));
                offset += spans[i];
            }
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                ...MSAProps,
                children: msaRow
            });
        }
    }
    renderControls() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                    className: "viz-wrapper",
                    transform: `translate(${this.props.xOffset},3)`,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                        width: this.props.width,
                        height: this.props.controlsHeight,
                        viewBox: this.getViewBox(true),
                        preserveAspectRatio: "none",
                        children: this.renderNode(this.props.rootNode)
                    })
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
                    x: this.props.xOffset,
                    y: this.props.yOffset,
                    width: this.props.width,
                    height: this.props.controlsHeight + 6,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                        className: "resize-container",
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                            ref: this.zoomerRef,
                            className: "resize-drag",
                            style: {
                                height: this.props.controlsHeight + 6
                            }
                        })
                    })
                })
            ]
        });
    }
    renderMSA() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
            x: this.props.xOffset,
            y: this.props.yOffset + this.props.controlsHeight + this.props.margin - 10,
            width: this.props.width,
            height: this.props.height + 2 * this.props.margin + 3,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                className: "MSAlignments-wrapper",
                children: this.props.nodes.map(this.renderSequence.bind(this))
            })
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                this.renderMSA(),
                this.renderControls()
            ]
        });
    }
}













class $64172895ffc11849$export$2e2bcd8739ae039 extends (0, $1i38n$react.Component) {
    static availableShapes() {
        return {
            triangle: {
                shape: function(opts) {
                    var halfWidth = Math.tan(Math.PI / 6) * opts.height;
                    return `M${opts.x + opts.width / 2},${opts.y} \
            l${halfWidth},${opts.height} \
            l${-halfWidth * 2},0 \
            Z`;
                }
            },
            bigSolidPointyRectangle: {
                shape: function(opts) {
                    let boxRatio = 0.75; //2 / 3;
                    let arrowRatio = 1 - boxRatio;
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    return `M${opts.x},${opts.y + opts.cornerRadius} \
            a${opts.cornerRadius},${opts.cornerRadius} 0 0 1 ${opts.cornerRadius},${-opts.cornerRadius}
            l${opts.width * boxRatio - opts.cornerRadius},0 \
            l${opts.width * arrowRatio},${opts.height / 2} \
            l${-opts.width * arrowRatio},${opts.height / 2} \
            l${-opts.width * boxRatio + opts.cornerRadius},0 \
            a${opts.cornerRadius},${opts.cornerRadius} 0 0 1 ${-opts.cornerRadius},${-opts.cornerRadius} \
            Z`;
                }
            },
            default: {
                shape: function(opts) {
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    return `M${opts.x},${opts.y + opts.height / 2} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${opts.width / 2},${-opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${opts.width / 2},${opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${-opts.width / 2},${opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${-opts.width / 2},${-opts.cornerRadius} \
            Z`;
                }
            },
            thinSolidPointyRectangle: {
                shape: function(opts) {
                    var squeezeFactor = 2 / 3;
                    opts.y += opts.height * (1 - squeezeFactor) / 2;
                    opts.height = opts.height * squeezeFactor;
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    opts.cornerRadius = opts.cornerRadius * squeezeFactor;
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().bigSolidPointyRectangle.shape.call(this, opts);
                }
            },
            bigStripedPointyRectangle: {
                shape: function(opts) {
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().bigSolidPointyRectangle.shape.call(this, opts);
                },
                mask: function() {
                    return "url('#mask-stripe')";
                }
            },
            thinStripedPointyRectangle: {
                shape: function(opts) {
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().thinSolidPointyRectangle.shape.call(this, opts);
                },
                mask: function() {
                    return "url('#mask-stripe')";
                }
            }
        };
    }
    static shapeMaster() {
        var availableShapes = $64172895ffc11849$export$2e2bcd8739ae039.availableShapes();
        return {
            "protein_coding": availableShapes.bigSolidPointyRectangle,
            "ncRNA": availableShapes.thinSolidPointyRectangle,
            "miRNA": availableShapes.thinStripedPointyRectangle,
            "snoRNA": availableShapes.thinSolidPointyRectangle,
            "tRNA": availableShapes.thinSolidPointyRectangle,
            "misc_RNA": availableShapes.thinSolidPointyRectangle,
            "transposable_element": availableShapes.bigStripedPointyRectangle,
            "lincRNA": availableShapes.thinSolidPointyRectangle,
            "nontranslating_CDS": availableShapes.bigStripedPointyRectangle,
            "tRNA_pseudogene": availableShapes.thinSolidPointyRectangle,
            "snRNA": availableShapes.thinSolidPointyRectangle,
            "rRNA": availableShapes.thinSolidPointyRectangle,
            "pseudogene": availableShapes.thinSolidPointyRectangle,
            "SRP_RNA": availableShapes.thinSolidPointyRectangle,
            "antisense": availableShapes.thinSolidPointyRectangle,
            "tmRNA": availableShapes.thinSolidPointyRectangle,
            "ribozyme": availableShapes.thinSolidPointyRectangle,
            "RNase_MRP_RNA": availableShapes.thinSolidPointyRectangle,
            "telomerase_RNA": availableShapes.thinSolidPointyRectangle,
            "P_RNA": availableShapes.thinSolidPointyRectangle,
            "RNase_P_RNA": availableShapes.thinSolidPointyRectangle,
            "vault_RNA": availableShapes.thinSolidPointyRectangle
        };
    }
    constructor(){
        super();
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            highlighted: false
        };
    }
    static biotypes() {
        return Object.keys($64172895ffc11849$export$2e2bcd8739ae039.shapeMaster()).sort();
    }
    stroke(highlighted, highlightColor, defaultColor) {
        return highlighted ? highlightColor : defaultColor;
    }
    strokeWidth(highlighted, highlightWidth) {
        return highlighted ? highlightWidth : 0;
    }
    height() {
        return this.props.height || this.props.width * 2 / 3;
    }
    cornerRadius(width, height) {
        return Math.floor(Math.min(this.props.width / 7.5, this.props.height / 2));
    }
    render() {
        var shapeStuff = $64172895ffc11849$export$2e2bcd8739ae039.shapeMaster()[this.props.gene.biotype] || $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().default;
        let d = shapeStuff.shape.call(this, {
            x: this.props.x,
            y: this.props.y,
            width: this.props.width,
            height: this.height()
        });
        const tooltip = this.props.tooltip ? /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Tooltip), {
            id: "tooltip",
            children: this.props.tooltip
        }) : null;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
            placement: this.props.tooltipPlacement,
            overlay: tooltip,
            trigger: "click",
            rootClose: true,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                transform: "translate(" + (this.props.gene.orientation === "+" ? 0 : this.props.x * 2 + this.props.width) + ",0) scale(" + (this.props.gene.orientation === "+" ? 1 : -1) + ",1)",
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("path", {
                    d: d,
                    fill: this.props.fillColor,
                    strokeWidth: this.strokeWidth(this.props.highlighted, this.props.highlightWidth),
                    stroke: this.stroke(this.props.highlighted, this.props.highlightColor, this.props.strokeColor),
                    //onClick= { this.handleClick }
                    //onDoubleClick={ this.handleClick }
                    opacity: this.props.opacity,
                    //onMouseOver = { this.tooltipOver.bind(this) }
                    //onMouseOut  = { this.tooltipOut.bind(this) }
                    mask: shapeStuff.mask ? shapeStuff.mask() : "",
                    cursor: "pointer"
                })
            })
        });
    }
    handleClick() {
        if (this.props.clickHandler) this.props.clickHandler(this.props.gene.id, this.props.gene.tree_id);
    }
    tooltipOver(e) {
        if (this.props.tooltipHandler) this.props.tooltipHandler(this.props.gene, e.pageX, e.pageY, true);
    }
    tooltipOut(e) {
        if (this.props.tooltipHandler) this.props.tooltipHandler(this.props.gene, e.pageX, e.pageY, false);
    }
}
$64172895ffc11849$export$2e2bcd8739ae039.defaultProps = {
    y: 0,
    orientation: "-",
    highlightWidth: 1,
    highlightColor: "cyan",
    tooltipPlacement: "bottom",
    opacity: "0.9"
};



const $842f43965c1e0716$var$neighborhoodHeight = 24;
const $842f43965c1e0716$var$scaleFactor = 20;
const $842f43965c1e0716$var$NeighborhoodArrow = (props)=>{
    const arrowLength = $842f43965c1e0716$var$scaleFactor * 10 * props.totalLength / props.width;
    const arrowHeight = 4;
    let lineLength = $842f43965c1e0716$var$scaleFactor * props.totalLength;
    let lineStart = 0;
    let lineEnd = lineLength;
    let arrowHead;
    let color = "black";
    let tooltip = "<pre>internal node</pre>";
    if (props.neighborhood && props.neighborhood.strand) {
        const flipped = props.neighborhood.strand === "reverse";
        lineStart = flipped ? arrowLength : 0;
        lineEnd = flipped ? lineLength : lineLength - arrowLength;
        const tipX = flipped ? 0 : lineLength;
        const tailX = flipped ? arrowLength : tipX - arrowLength;
        const tipY = $842f43965c1e0716$var$neighborhoodHeight / 2;
        const points = `${tipX},${tipY} ${tailX},${tipY + arrowHeight} ${tailX},${tipY - arrowHeight}`;
        color = props.neighborhood.region.color;
        arrowHead = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("polygon", {
            points: points,
            stroke: color,
            fill: color
        });
        const region = props.neighborhood.region;
        const system_name = props.neighborhood.genes[0].system_name;
        let syntenyURL = `${props.ensemblUrl}/${system_name}/Location/Synteny?r=${region.name}:${region.start}-${region.end}`;
        let tooltipFields = [
            [
                "region",
                region.name
            ],
            [
                "start",
                region.start
            ],
            [
                "end",
                region.end
            ],
            [
                "",
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                    href: syntenyURL,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: `Synteny browser`
                })
            ]
        ];
        tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Tooltip), {
            id: region.name + ":" + region.start,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("table", {
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("tbody", {
                    children: tooltipFields.map((tip, i)=>{
                        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
                            style: {
                                verticalAlign: "top"
                            },
                            children: [
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("th", {
                                    children: tip[0]
                                }),
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                                    style: {
                                        color: "lightgray",
                                        textAlign: "left",
                                        paddingLeft: "15px"
                                    },
                                    children: tip[1]
                                })
                            ]
                        }, i);
                    })
                })
            })
        });
    }
    let tickMarks = [];
    for(let i = 1 * $842f43965c1e0716$var$scaleFactor; i < lineLength; i += $842f43965c1e0716$var$scaleFactor){
        let tick = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
            x1: i,
            y1: 4,
            x2: i,
            y2: 20,
            stroke: color,
            strokeWidth: "0.25"
        }, i);
        tickMarks.push(tick);
    }
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
                placement: "left",
                overlay: tooltip,
                trigger: "click",
                rootClose: true,
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
                    x1: lineStart,
                    y1: $842f43965c1e0716$var$neighborhoodHeight / 2,
                    x2: lineEnd,
                    y2: $842f43965c1e0716$var$neighborhoodHeight / 2,
                    stroke: color,
                    strokeWidth: "3",
                    cursor: "pointer"
                })
            }),
            tickMarks,
            arrowHead
        ]
    });
};
const $842f43965c1e0716$var$ComparaGene = (props)=>{
    const gene = props.gene;
    const geneWidth = 0.6 * $842f43965c1e0716$var$scaleFactor;
    const geneHeight = 16;
    const identityScale = $1i38n$d3scale.scaleLinear().domain([
        1,
        0
    ]).range([
        props.color,
        "white"
    ]);
    const identity = gene.relationToGeneOfInterest ? gene.relationToGeneOfInterest.identity : 1;
    const highlighted = props.highlighted[gene.tree_id];
    let syntenyURL = `${props.ensemblUrl}/${gene.system_name}/Location/Synteny?r=${gene.region}:${gene.start}-${gene.end}:${gene.orientation}`;
    let tooltipFields = [
        [
            "Gene ID",
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                href: `?idList=${gene.id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                children: gene.id
            })
        ],
        [
            "Gene Name",
            gene.name
        ],
        // ['Taxonomy',    props.taxonomy.taxonIdToSpeciesName[gene.taxon_id]],
        [
            "Region",
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                href: syntenyURL,
                target: "_blank",
                rel: "noopener noreferrer",
                children: `${gene.region}:${gene.start}-${gene.end}:${gene.orientation}`
            })
        ],
        [
            "Tree ID",
            gene.tree_id
        ],
        //['Tree Root',   this.props.taxonomy.taxonIdToSpeciesName[gene.gene_tree_root_taxon_id]],
        // ['Biotype',     gene.biotype],
        [
            "Description",
            gene.description
        ]
    ];
    if (gene.closest_rep_id) tooltipFields.push([
        "Homolog",
        gene.closest_rep_description
    ]);
    else if (gene.model_rep_id) tooltipFields.push([
        "Homolog",
        gene.model_rep_description
    ]);
    let button = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.Button), {
        size: "sm",
        onClick: ()=>{
            if (props.clickHandler) props.clickHandler(gene.id, gene.tree_id);
        },
        children: [
            highlighted ? "Unhighlight" : "Highlight",
            " this gene tree"
        ]
    });
    if (gene.relationToGeneOfInterest) tooltipFields.push([
        "Identity",
        Math.floor(1000 * identity) / 10 + "%"
    ]);
    const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("table", {
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
            children: [
                tooltipFields.map((tip, i)=>{
                    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
                        style: {
                            verticalAlign: "top"
                        },
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("th", {
                                children: tip[0]
                            }),
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                                style: {
                                    color: "lightgray",
                                    textAlign: "left",
                                    paddingLeft: "15px"
                                },
                                children: tip[1]
                            })
                        ]
                    }, i);
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("tr", {
                    style: {
                        verticalAlign: "top"
                    },
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                        colSpan: "2",
                        children: button
                    })
                })
            ]
        })
    });
    const centerStrokeLine = props.center ? /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
        x1: gene.x * $842f43965c1e0716$var$scaleFactor,
        y1: geneHeight / 4 - 2,
        x2: gene.x * $842f43965c1e0716$var$scaleFactor,
        y2: geneHeight / 4 + geneHeight + 2,
        stroke: "red",
        strokeWidth: "1"
    }) : null;
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $64172895ffc11849$export$2e2bcd8739ae039), {
                width: geneWidth,
                height: geneHeight,
                gene: gene,
                x: gene.x * $842f43965c1e0716$var$scaleFactor - geneWidth / 2,
                y: geneHeight / 4,
                fillColor: gene.relationToGeneOfInterest ? identityScale(identity) : props.color,
                highlightColor: highlighted ? "cyan" : props.color,
                tooltip: tooltip,
                highlighted: highlighted || props.center,
                opacity: undefined,
                clickHandler: ()=>{
                    if (props.clickHandler) props.clickHandler(gene.id, gene.tree_id);
                }
            }, "H-" + gene.id),
            centerStrokeLine
        ]
    });
};
const $842f43965c1e0716$var$NonCodingGroup = (props)=>{
    let x = +props.x * $842f43965c1e0716$var$scaleFactor;
    let n = props.genes.length;
    const ncgWidth = 0.3 * $842f43965c1e0716$var$scaleFactor;
    const ncgHeight = 16;
    const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.Tooltip), {
        id: "tooltip",
        children: [
            "Non-coding group with ",
            n,
            " gene",
            n > 1 ? "s" : ""
        ]
    });
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.OverlayTrigger), {
        placement: "top",
        overlay: tooltip,
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
            x: x - ncgWidth / 2,
            y: 6,
            width: ncgWidth,
            height: 12,
            rx: ncgWidth / 6,
            ry: ncgHeight / 6,
            fill: props.scale(n)
        })
    });
};
function $842f43965c1e0716$var$treeIDToColor(tree_id, treeMap, scale) {
    if (tree_id === undefined) return "dimgray";
    else if (treeMap[tree_id] === undefined) return "lightgray";
    return scale(treeMap[tree_id]);
}
class $842f43965c1e0716$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        let comparaGenes = [];
        let nonCodingGenes = [];
        let neighborhood = this.props.neighborhood;
        if (neighborhood) {
            let nonCodingGeneGroup = {};
            let center_x = this.props.totalLength / 2;
            let centralGene = neighborhood.genes[neighborhood.center_idx];
            let treeInfo = this.props.treeInfo;
            if (neighborhood.strand === "reverse") neighborhood.genes.forEach((gene, gene_idx)=>{
                gene.x = center_x + (centralGene.compara_idx - gene.compara_idx);
                if (gene.gene_tree) {
                    const treeColor = $842f43965c1e0716$var$treeIDToColor(gene.tree_id, treeInfo.treeMap, treeInfo.scale);
                    comparaGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$ComparaGene, {
                        gene: gene,
                        color: treeColor,
                        center: gene_idx === neighborhood.center_idx,
                        clickHandler: this.props.clickHandler,
                        highlighted: this.props.highlighted
                    }, gene.x));
                } else {
                    gene.x = center_x + (centralGene.compara_idx - gene.compara_idx + 0.5);
                    if (!nonCodingGeneGroup.hasOwnProperty(gene.x)) nonCodingGeneGroup[gene.x] = [];
                    nonCodingGeneGroup[gene.x].push(gene);
                }
            });
            else neighborhood.genes.forEach((gene, gene_idx)=>{
                gene.x = center_x - (centralGene.compara_idx - gene.compara_idx);
                if (gene.gene_tree) {
                    const treeColor = $842f43965c1e0716$var$treeIDToColor(gene.tree_id, treeInfo.treeMap, treeInfo.scale);
                    comparaGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$ComparaGene, {
                        gene: gene,
                        color: treeColor,
                        center: gene_idx === neighborhood.center_idx,
                        clickHandler: this.props.clickHandler,
                        highlighted: this.props.highlighted,
                        ensemblUrl: this.props.ensemblUrl
                    }, gene.x));
                } else {
                    gene.x = center_x - (centralGene.compara_idx - gene.compara_idx + 0.5);
                    if (!nonCodingGeneGroup.hasOwnProperty(gene.x)) nonCodingGeneGroup[gene.x] = [];
                    nonCodingGeneGroup[gene.x].push(gene);
                }
            });
            const ncgScale = $1i38n$d3scale.scaleLinear().domain([
                this.props.maxNCGGenes,
                1
            ]).range([
                "#333333",
                "lightgray"
            ]);
            for(let x in nonCodingGeneGroup)nonCodingGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$NonCodingGroup, {
                x: x,
                genes: nonCodingGeneGroup[x],
                scale: ncgScale
            }, x));
        }
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            className: "Neighborhood",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$NeighborhoodArrow, {
                    ensemblUrl: this.props.ensemblUrl,
                    neighborhood: neighborhood,
                    width: this.props.width,
                    totalLength: this.props.totalLength
                }),
                comparaGenes,
                nonCodingGenes
            ]
        });
    }
}


class $ced8d699a1299cf4$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        let px = isStyle ? "px" : "";
        let x = 0;
        let y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        let props = {};
        if (0, $62e50bff44daad79$export$2e2bcd8739ae039) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $842f43965c1e0716$export$2e2bcd8739ae039), {
                ...this.props
            })
        });
    }
}



function $86f31c7466377268$var$initTreeColors(primary_neighborhood) {
    var range = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "indigo",
        "darkviolet"
    ];
    if (primary_neighborhood.strand === "reverse") range = range.reverse();
    let treeMap = {}; // key is tree_id value is a number based on relative position in neighborhood
    var center_idx = Number(primary_neighborhood.center_idx); // always green
    var center_gene = primary_neighborhood.genes[center_idx];
    let d = 0;
    treeMap[center_gene.tree_id] = d;
    var i, nLeft = 0, nRight = 0;
    // trees left of center
    for(i = center_idx - 1; i >= 0; i--){
        var gene = primary_neighborhood.genes[i];
        if (gene.tree_id && !treeMap[gene.tree_id]) {
            treeMap[gene.tree_id] = --d;
            nLeft--;
        }
    }
    // trees right of center
    d = 0;
    for(i = center_idx + 1; i < primary_neighborhood.genes.length; i++){
        gene = primary_neighborhood.genes[i];
        if (gene.tree_id && !treeMap[gene.tree_id]) {
            treeMap[gene.tree_id] = ++d;
            nRight++;
        }
    }
    var domain = [
        nLeft,
        2 * nLeft / 3,
        nLeft / 3,
        0,
        nRight / 3,
        2 * nRight / 3,
        nRight
    ];
    if (nLeft === 0) {
        domain = domain.slice(3);
        range = range.slice(3);
    }
    if (nRight === 0) {
        domain = domain.reverse().slice(3).reverse();
        range = range.reverse().slice(3).reverse();
    }
    var scale = $1i38n$d3scale.scaleLinear().domain(domain).range(range);
    if (domain.length === 1) scale = function(value) {
        return "green";
    };
    return {
        scale: scale,
        treeMap: treeMap
    };
}
class $86f31c7466377268$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            highlighted: {}
        };
        // this.svgRef = React.createRef();
        this.totalLength = 2 + 2 * props.numberOfNeighbors;
        this.viewRange = {
            min: props.numberOfNeighbors / 2,
            max: .75 * this.totalLength
        };
        this.minWidth = props.width * 4 / this.totalLength;
        if (this.viewRange.max - this.viewRange.min <= this.minWidth) {
            this.viewRange.min = 0;
            this.viewRange.max = this.totalLength;
        }
    }
    // componentDidMount() {
    // }
    // componentDidMount() {
    //   if (this.zoomer) {
    //     let x = this.props.width * this.viewRange.min / this.totalLength;
    //     let y = parseFloat(this.zoomer.getAttribute('data-y')) || 0;
    //     this.zoomer.style.webkitTransform =
    //       this.zoomer.style.transform =
    //         `translate(${x}px,${y}px)`;
    //     this.zoomer.style.width = this.props.width * (this.viewRange.max - this.viewRange.min)/this.totalLength + 'px';
    //     interact(this.zoomer)
    //       .draggable({
    //         onmove: this.dragMoveListener.bind(this)
    //       })
    //       .resizable({
    //         preserveAspectRatio: false,
    //         edges: {left: true, right: true, bottom: false, top: false }
    //       })
    //       .on('resizemove', function (event) {
    //         if (event.rect.width > this.minWidth) {
    //           let target = event.target;
    //           let x = this.props.width * this.viewRange.min / this.totalLength;
    //           let y = (parseFloat(target.getAttribute('data-y')) || 0);
    //           if (event.deltaRect.left !== 0) {
    //             // move left edge
    //             x += event.deltaRect.left;
    //             if (x < 0) x = 0;
    //             this.viewRange.min = x * this.totalLength / this.props.width;
    //           }
    //           if (event.deltaRect.right !== 0) {
    //             // move right edge
    //             let right = x + event.rect.width;
    //             if (right > this.props.width) right = this.props.width;
    //             this.viewRange.max = right * this.totalLength / this.props.width;
    //           }
    //
    //           let viewWidth = this.viewRange.max - this.viewRange.min;
    //           target.style.width = this.props.width * viewWidth / this.totalLength + 'px';
    //           target.style.webkitTransform =
    //             target.style.transform =
    //               `translate(${x}px,${y}px)`;
    //           target.setAttribute('data-x', x);
    //           target.setAttribute('data-width', parseInt(target.style.width, 10));
    //
    //           this.svgRef.current.setAttribute('viewBox', this.getViewBox(false));
    //         }
    //       }.bind(this))
    //   }
    // }
    //
    // dragMoveListener(event) {
    //   if ((this.viewRange.max - this.viewRange.min + 1) < 0.98*this.totalLength) {
    //     let target = event.target,
    //       x = this.props.width * this.viewRange.min / this.totalLength + event.dx,
    //       y = parseFloat(target.getAttribute('data-y')) || 0;
    //     // respect boundaries
    //     if (x < 0) x = 0;
    //     let zoomerWidth = parseFloat(target.style.width);
    //     if (x + zoomerWidth > this.props.width) x = this.props.width - zoomerWidth;
    //     let xPosInSeq = this.totalLength * x / this.props.width;
    //     let viewWidth = this.viewRange.max - this.viewRange.min;
    //     // translate the element
    //     target.style.webkitTransform =
    //       target.style.transform =
    //         'translate(' + x + 'px, ' + y + 'px)';
    //     // update the position attribute
    //     target.setAttribute('data-x', x);
    //     // update the view position
    //     this.viewRange.min = xPosInSeq;
    //     this.viewRange.max = xPosInSeq + viewWidth;
    //
    //     this.svgRef.current.setAttribute('viewBox', this.getViewBox(false));
    //   }
    // }
    getViewBox(forConsensus) {
        let viewBoxMinX = forConsensus ? 0 : this.viewRange.min;
        let viewBoxMinY = 0;
        let viewBoxWidth = forConsensus ? this.totalLength : this.viewRange.max - this.viewRange.min;
        let viewBoxHeight = forConsensus ? this.props.controlsHeight : this.props.height + 2 * this.props.margin;
        return `${viewBoxMinX * 20} ${viewBoxMinY} ${viewBoxWidth * 20} ${viewBoxHeight}`;
    }
    getNeighborhood(node) {
        return node.model.gene_stable_id ? this.props.neighborhoods[node.model.gene_stable_id] : {
            genes: []
        };
    }
    renderNode(node, treeInfo) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let neighborhood = this.getNeighborhood(node);
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $ced8d699a1299cf4$export$2e2bcd8739ae039), {
                    node: node,
                    width: this.props.width,
                    totalLength: this.totalLength,
                    neighborhood: neighborhood,
                    maxNCGGenes: this.props.maxNCGGenes,
                    treeInfo: treeInfo,
                    highlighted: this.state.highlighted,
                    ensemblUrl: this.props.ensemblUrl,
                    clickHandler: (gene_id, tree_id)=>{
                        let highlighted = {
                            ...this.state.highlighted
                        };
                        highlighted[tree_id] = !highlighted[tree_id];
                        this.setState({
                            highlighted: highlighted
                        });
                    }
                })
            }, node.model.node_id);
        }
    }
    render() {
        let treeInfo = $86f31c7466377268$var$initTreeColors(this.getNeighborhood(this.props.queryNode));
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "phyloview-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset + this.props.controlsHeight + this.props.margin - 10})`,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                width: this.props.width,
                height: this.props.height + 2 * this.props.margin,
                viewBox: this.getViewBox(false),
                preserveAspectRatio: "none",
                children: this.props.nodes.map((node)=>{
                    return this.renderNode(node, treeInfo);
                })
            })
        });
    }
}





const $d4db98f04dcc88a8$var$shifty = {
    curate: "okay",
    okay: "flag",
    // unclear: 'curate',
    flag: "curate"
};
let $d4db98f04dcc88a8$var$reasons = [
    {
        name: "none",
        label: "choose a reason"
    }
];
let $d4db98f04dcc88a8$var$groups = [
    {
        name: "none",
        label: "choose a group"
    },
    {
        name: "A",
        label: "A"
    },
    {
        name: "B",
        label: "B"
    }
];
const $d4db98f04dcc88a8$var$combos = [
    "G__",
    "L__",
    "_G_",
    "_L_",
    "__G",
    "__L",
    "GG_",
    "GL_",
    "G_G",
    "G_L",
    "GGG",
    "GGL",
    "GLG",
    "GLL",
    "LG_",
    "LL_",
    "L_G",
    "L_L",
    "LGG",
    "LGL",
    "LLG",
    "LLL",
    "_GG",
    "_GL",
    "_LG",
    "_LL"
];
$d4db98f04dcc88a8$var$combos.forEach((c)=>{
    $d4db98f04dcc88a8$var$reasons.push({
        name: c,
        label: c.split("").join(",")
    });
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "split",
    label: "split gene"
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "fusion",
    label: "fused gene"
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "other",
    label: "other"
});
class $d4db98f04dcc88a8$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        let opinion = [];
        let reason = [];
        let group = [];
        props.nodes.forEach((node)=>{
            if (node.model.gene_stable_id && (props.curatable.all || props.curatable[node.model.taxon_id])) {
                opinion[node.model.gene_stable_id] = "curate";
                reason[node.model.gene_stable_id] = "none";
                group[node.model.gene_stable_id] = "none";
            }
        });
        this.state = {
            opinion: opinion,
            reason: reason,
            group: group
        };
    }
    componentWillReceiveProps(nextProps) {
        if (!(0, ($parcel$interopDefault($1i38n$lodash))).isEqual(nextProps, this.state.props)) {
            let opinion = this.state.opinion;
            let doUpdate = false;
            nextProps.nodes.forEach((node)=>{
                const id = node.model.gene_stable_id;
                if (id && !this.state.opinion[id] && (nextProps.curatable.all || nextProps.curatable[node.model.taxon_id])) opinion[id] = "curate";
            });
            if (doUpdate) this.setState({
                opinion: opinion
            });
        }
    }
    flipFlop(node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        opinion[id] = $d4db98f04dcc88a8$var$shifty[opinion[id]];
        this.setState({
            opinion: opinion
        });
        this.props.getCuration(opinion, reason, group);
    }
    changeReason(e, node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        reason[id] = e.target.value;
        this.setState({
            reason: reason
        });
        this.props.getCuration(opinion, reason, group);
    }
    changeGroup(e, node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        group[id] = e.target.value;
        this.setState({
            group: group
        });
        this.props.getCuration(opinion, reason, group);
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "curation-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset})`,
            children: this.props.nodes.map((node, idx)=>{
                if (node.model.gene_stable_id && (this.props.curatable.all || this.props.curatable[node.model.taxon_id])) {
                    const opinion = this.state.opinion[node.model.gene_stable_id];
                    const reason = this.state.reason[node.model.gene_stable_id] || "none";
                    const group = this.state.group[node.model.gene_stable_id] || "none";
                    let reasonSelect;
                    if (opinion === "flag") reasonSelect = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                        className: "curation-reason",
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("select", {
                            value: reason,
                            name: node.model.gene_stable_id,
                            onChange: (e)=>this.changeReason(e, node),
                            children: $d4db98f04dcc88a8$var$reasons.map((r, idx)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("option", {
                                    value: r.name,
                                    children: r.label
                                }, idx))
                        })
                    });
                    let groupSelect;
                    // if (opinion === 'unclear') {
                    //   groupSelect = (<span className='curation-group'>
                    //     <select value={group} name={node.model.gene_stable_id} onChange={(e) => this.changeGroup(e,node)}>
                    //       {groups.map((g,idx) => (
                    //         <option key={idx} value={g.name}>{g.label}</option>
                    //       ))}
                    //     </select>
                    //   </span>)
                    // }
                    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("foreignObject", {
                        x: 10,
                        y: node.x - 4,
                        height: this.props.height,
                        width: this.props.width,
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                className: `curation ${opinion}`,
                                onClick: ()=>this.flipFlop(node),
                                children: opinion
                            }),
                            reasonSelect,
                            groupSelect
                        ]
                    }, idx);
                }
                return "";
            })
        });
    }
}




const $1f9b52c72af6ed55$var$Spinner = (props)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
        x: props.xOffset,
        y: props.yOffset,
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            className: "spinner",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce1"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce2"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce3"
                })
            ]
        })
    });
var $1f9b52c72af6ed55$export$2e2bcd8739ae039 = $1f9b52c72af6ed55$var$Spinner;








let $8c542044289fc59b$var$calculateIdentity = $1i38n$gramenetreesclient.extensions.identity;
function $8c542044289fc59b$var$relateNodesToGeneOfInterest(genetree, geneOfInterest, taxonomy, pivotTree) {
    $8c542044289fc59b$var$addHomologyInformationToNodes(genetree, geneOfInterest);
    $8c542044289fc59b$var$addTaxonDistanceInformationToNodes(genetree, geneOfInterest, taxonomy);
    if (pivotTree) {
        let node = genetree.indices.gene_stable_id[geneOfInterest._id];
        const indexCallback = (n)=>n === node;
        while(!node.isRoot()){
            const parent = node.parent;
            const children = parent.children;
            const nodeIdx = (0, ($parcel$interopDefault($1i38n$lodash))).findIndex(children, indexCallback);
            // move this node to the front of the children array.
            if (nodeIdx) children.splice(0, 0, children.splice(nodeIdx, 1)[0]);
            node = parent;
        }
    }
}
function $8c542044289fc59b$var$addHomologyInformationToNodes(genetree, theGene) {
    if (theGene) {
        let theGeneNode = genetree.indices.gene_stable_id[theGene._id];
        let homologs = $8c542044289fc59b$var$indexHomologs(theGene);
        let representatives = $8c542044289fc59b$var$indexReps(theGene);
        // recursive function that sorts children by identity
        function sortByIdentity(node) {
            let homology;
            let nodeId = node.model.gene_stable_id;
            if (!node.hasOwnProperty("relationToGeneOfInterest")) node.relationToGeneOfInterest = {};
            if (nodeId) {
                if (nodeId === theGene._id) homology = "self";
                else homology = homologs[nodeId];
                node.relationToGeneOfInterest.identity = $8c542044289fc59b$var$calculateIdentity(theGeneNode, node);
                node.relationToGeneOfInterest.homology = homology;
                node.relationToGeneOfInterest.repType = representatives[nodeId];
                if (!node.model.gene_display_label) node.model.gene_display_label = `[${nodeId}]`;
            } else {
                node.children.forEach(function(child) {
                    sortByIdentity(child);
                });
                node.children = (0, ($parcel$interopDefault($1i38n$lodash))).sortBy(node.children, function(n) {
                    return 1.0 - n.relationToGeneOfInterest.identity;
                });
                node.relationToGeneOfInterest.identity = node.children[0].relationToGeneOfInterest.identity;
            }
        }
        sortByIdentity(genetree);
    }
}
// IN -> key: homologyType, value: [geneId]
// OUT-> key: geneId, value: homologyType
function $8c542044289fc59b$var$indexHomologs(theGene) {
    let homologs = (0, ($parcel$interopDefault($1i38n$lodash))).get(theGene, "homology.homologous_genes");
    return (0, ($parcel$interopDefault($1i38n$lodash))).transform(homologs, function(result, value, key) {
        (0, ($parcel$interopDefault($1i38n$lodash))).forEach(value, function(id) {
            result[id] = key;
        });
        return result;
    }, {});
}
// IN -> key: representativeType, value: gene doc
// OUT-> key: geneId, value: representativeType
function $8c542044289fc59b$var$indexReps(theGene) {
    let representative = (0, ($parcel$interopDefault($1i38n$lodash))).get(theGene, "homology.gene_tree.representative");
    return (0, ($parcel$interopDefault($1i38n$lodash))).transform(representative, function(result, rep, repType) {
        result[rep.id] = repType;
        return result;
    }, {});
}
function $8c542044289fc59b$var$addTaxonDistanceInformationToNodes(genetree, geneOfInterest, taxonomy) {
    /*const*/ var OUTGROUP_FLAG = -1;
    let theGeneTaxonId = geneOfInterest.taxon_id;
    if (theGeneTaxonId && taxonomy) {
        let theTaxonNode = taxonomy.indices.id[theGeneTaxonId];
        let theTaxonPath = theTaxonNode.getPath();
        let theTaxonPathIds = (0, ($parcel$interopDefault($1i38n$lodash))).keyBy(theTaxonPath, "model.id");
        let relationLUT = {};
        let maxima = {
            lcaDistance: 0,
            pathDistance: 0
        };
        genetree.walk(function(node) {
            let nodeTaxonId = node.model.taxon_id || node.model.node_taxon_id;
            // have we already seen this?
            if (relationLUT[nodeTaxonId]) node.relationToGeneOfInterest.taxonomy = relationLUT[nodeTaxonId];
            else {
                let lcaDistance = 0;
                let pathDistance = 0;
                let lca;
                if (nodeTaxonId !== theGeneTaxonId) {
                    lca = theTaxonPathIds[nodeTaxonId];
                    if (lca) pathDistance = 0;
                    else {
                        let nodeTaxon = taxonomy.indices.id[nodeTaxonId];
                        if (nodeTaxon) {
                            lca = theTaxonNode.lcaWith([
                                nodeTaxon
                            ]);
                            pathDistance = lca.pathTo(nodeTaxon).length - 1;
                        } else pathDistance = OUTGROUP_FLAG;
                    }
                    if (pathDistance === OUTGROUP_FLAG) lcaDistance = OUTGROUP_FLAG;
                    else lcaDistance = theTaxonPath.length - (0, ($parcel$interopDefault($1i38n$lodash))).indexOf(theTaxonPath, lca) - 1;
                }
                let distances = {
                    lcaDistance: lcaDistance,
                    pathDistance: pathDistance,
                    maxima: maxima
                };
                maxima.lcaDistance = Math.max(maxima.lcaDistance, distances.lcaDistance);
                maxima.pathDistance = Math.max(maxima.pathDistance, distances.pathDistance);
                relationLUT[nodeTaxonId] = node.relationToGeneOfInterest.taxonomy = distances;
            }
        });
        // any taxa we don't have in the taxonomy tree, we will set to the max values seen.
        // it's ok to modify values in the LUT because these point to the same refs as the nodes.
        (0, ($parcel$interopDefault($1i38n$lodash))).forIn(relationLUT, function updateOutgroupTaxa(distances) {
            if (distances.lcaDistance === OUTGROUP_FLAG) {
                distances.lcaDistance = maxima.lcaDistance;
                distances.pathDistance = maxima.pathDistance;
            }
        });
        maxima.colorScale = $1i38n$d3scale.scaleLinear().domain([
            0,
            maxima.lcaDistance + maxima.pathDistance
        ]).range([
            "green",
            "red"
        ]);
    }
}
var $8c542044289fc59b$export$2e2bcd8739ae039 = $8c542044289fc59b$var$relateNodesToGeneOfInterest;



const $f7e47e6ef7e802bb$var$PIXELS_PER_X_INDEX = 18;
const $f7e47e6ef7e802bb$var$DEFAULT_SVG_HEIGHT = 250;
function $f7e47e6ef7e802bb$var$calculateSvgHeight(genetree) {
    if (genetree && (0, ($parcel$interopDefault($1i38n$lodash))).isNumber(genetree.minXindex) && (0, ($parcel$interopDefault($1i38n$lodash))).isNumber(genetree.maxXindex)) return (genetree.maxXindex - genetree.minXindex) * $f7e47e6ef7e802bb$var$PIXELS_PER_X_INDEX;
    else return $f7e47e6ef7e802bb$var$DEFAULT_SVG_HEIGHT;
}
var $f7e47e6ef7e802bb$export$2e2bcd8739ae039 = $f7e47e6ef7e802bb$var$calculateSvgHeight;



function $1ec57391cf50db74$export$2e2bcd8739ae039(genetree, w, h) {
    const MIN_DIST = 0.05;
    const MAX_DIST = 2;
    let xscale = $1i38n$d3scale.scaleLinear().domain([
        genetree.minXindex,
        genetree.maxXindex
    ]).range([
        0,
        h
    ]);
    let maxExpandedDist = 0;
    let expandedNodes = [];
    genetree.walk(function(node) {
        let parentDist = Math.max(node.model.distance_to_parent, MIN_DIST) || 0;
        while(parentDist > MAX_DIST)parentDist /= 10;
        node.root_dist = (node.parent ? node.parent.root_dist : 0) + parentDist;
        if (!node.parent || node.parent.displayInfo.expanded) {
            node.x = xscale(node.xindex);
            expandedNodes.push(node);
            if (node.root_dist > maxExpandedDist) maxExpandedDist = node.root_dist;
        }
    });
    let yscale = $1i38n$d3scale.scaleLinear().domain([
        0,
        maxExpandedDist
    ]).range([
        0,
        w
    ]);
    return expandedNodes.map(function(node) {
        node.y = yscale(node.root_dist);
        return node;
    });
}



function $f295311ee73679ba$export$8b60bd6775d46208(node) {
    node.displayInfo.expanded = true;
}
function $f295311ee73679ba$export$3e625f118b045824(node) {
    node.displayInfo.expanded = false;
}
function $f295311ee73679ba$export$d865796a5b4a7f49(node) {
    node.walk($f295311ee73679ba$export$8b60bd6775d46208);
}
function $f295311ee73679ba$export$5be4099be9306efa(node) {
    node.walk($f295311ee73679ba$export$3e625f118b045824);
}
function $f295311ee73679ba$var$compressLongTaxonName(node) {
    const fullName = node.model.taxon_name;
    const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, "");
    let finalVersion;
    if (removedExtraineousWords.length > 20) {
        let words = removedExtraineousWords.split(" ");
        if (words.length === 2) // abrreviate first word.
        finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, "$1.");
        if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, "$1$2.");
    } else finalVersion = removedExtraineousWords;
    node.model.taxon_name = finalVersion;
}
function $f295311ee73679ba$export$e2f5f157c8e85aef(node) {
    node.walk($f295311ee73679ba$var$compressLongTaxonName);
}
function $f295311ee73679ba$export$cbecd1a31826c595(genetree) {
    let visibleUnexpanded = []; // array of unexpanded nodes that are visible
    function calcXIndexFor(node) {
        if (node.displayInfo.expanded && node.children.length > 0) {
            if (node.children.length === 2) {
                let leftExtrema = calcXIndexFor(node.children[0]); // left child
                let rightExtrema = calcXIndexFor(node.children[1]); // right child
                node.xindex = (rightExtrema.min + leftExtrema.max) / 2; // midpoint
                return {
                    min: leftExtrema.min,
                    max: rightExtrema.max
                };
            } else {
                let childExtrema = calcXIndexFor(node.children[0]);
                node.xindex = node.children[0].xindex;
                return {
                    min: childExtrema.min,
                    max: childExtrema.max
                };
            }
        } else {
            visibleUnexpanded.push(node);
            node.xindex = visibleUnexpanded.length;
            return {
                min: node.xindex,
                max: node.xindex
            };
        }
    }
    let treeExtrema = calcXIndexFor(genetree);
    genetree.maxXindex = treeExtrema.max;
    genetree.minXindex = treeExtrema.min;
}
function $f295311ee73679ba$export$6ec9a7cb49676029(genetree, geneOfInterest, expandRepresentatives) {
    let pathIds = getPathIds(expandRepresentatives);
    let paralogPathIds = getParalogPathIds();
    let orthologPathIds = null; //getOrthologPathIds();
    genetree.walk(function(node) {
        let nodeId = node.model.node_id;
        let isLeafNode = !!node.model.gene_stable_id;
        let onlyChild = node.children && node.children.length === 1;
        let displayInfo = {
            expanded: false,
            leafNode: isLeafNode,
            isGeneOfInterest: node.model.gene_stable_id === geneOfInterest._id
        };
        if (!!pathIds[nodeId]) {
            displayInfo.expanded = true;
            displayInfo.expandedBecause = pathIds[nodeId];
        } else if (node.parent) {
            let parentNodeId = node.parent.model.node_id;
            if ((isLeafNode || onlyChild) && pathIds[parentNodeId]) {
                displayInfo.expanded = true;
                displayInfo.expandedBecause = pathIds[parentNodeId];
                pathIds[node.model.node_id] = [
                    node
                ];
            }
        }
        displayInfo.paralogs = paralogPathIds ? paralogPathIds[nodeId] : [];
        displayInfo.orthologs = orthologPathIds ? orthologPathIds[nodeId] : [];
        node.displayInfo = displayInfo;
    });
    function getPathIds(expandRepresentatives) {
        let representatives = expandRepresentatives && (0, ($parcel$interopDefault($1i38n$lodash))).get(geneOfInterest.homology.gene_tree, "representative");
        // get nodes of representatives and gene of interest.
        let nodesToExpand = representatives ? (0, ($parcel$interopDefault($1i38n$lodash))).map(representatives, (rep)=>idToNode(rep.id)) : [];
        nodesToExpand.push(idToNode(geneOfInterest._id));
        // get and index all node_ids in the paths for those nodes.
        // these are the ones that should be expanded by default.
        return (0, ($parcel$interopDefault($1i38n$lodash))).reduce(nodesToExpand, nodesToPathIds, {});
    }
    function pathIdsImpl(path) {
        let ids = (0, ($parcel$interopDefault($1i38n$lodash))).get(geneOfInterest, path);
        if (!ids) return null;
        ids.push(geneOfInterest._id);
        let nodes = (0, ($parcel$interopDefault($1i38n$lodash))).map(ids, idToNode);
        return (0, ($parcel$interopDefault($1i38n$lodash))).reduce(nodes, nodesToPathIds, {});
    }
    function getParalogPathIds() {
        return pathIdsImpl("homology.homologous_genes.within_species_paralog");
    }
    function getOrthologPathIds() {
        let keys = (0, ($parcel$interopDefault($1i38n$lodash))).keys((0, ($parcel$interopDefault($1i38n$lodash))).get(geneOfInterest, "homology.homologous_genes")).map(function(key) {
            return "homology.homologous_genes." + key;
        });
        let filteredKeys = (0, ($parcel$interopDefault($1i38n$lodash))).filter(keys, function(key) {
            return key.indexOf("ortholog") > -1;
        });
        let pathIdsArray = (0, ($parcel$interopDefault($1i38n$lodash))).map(filteredKeys, pathIdsImpl);
        return (0, ($parcel$interopDefault($1i38n$lodash))).reduce(pathIdsArray, function(acc, obj) {
            return (0, ($parcel$interopDefault($1i38n$lodash))).mergeWith(acc, obj, function mergeIndexedPathIds(accVal, objVal) {
                return (0, ($parcel$interopDefault($1i38n$lodash))).isArray(accVal) ? accVal.concat(objVal) : objVal;
            });
        });
    }
    function idToNode(id) {
        return genetree.indices.gene_stable_id[id];
    }
    function nodesToPathIds(acc, node) {
        // take an array of nodes, return an object with
        // key: pathNodeId
        // value: array of actual nodes (not the ones in the path).
        if (!node) return acc;
        let paralogPairs = (0, ($parcel$interopDefault($1i38n$lodash))).map(node.getPath(), function(n) {
            return [
                n.model.node_id,
                node
            ];
        });
        let paralogLUT = (0, ($parcel$interopDefault($1i38n$lodash))).fromPairs(paralogPairs);
        return (0, ($parcel$interopDefault($1i38n$lodash))).assignWith(acc, paralogLUT, function(accVal, srcVal) {
            return (0, ($parcel$interopDefault($1i38n$lodash))).isUndefined(accVal) ? [
                srcVal
            ] : (0, ($parcel$interopDefault($1i38n$lodash))).concat(accVal, srcVal);
        });
    }
}












const $bc2bf29db86f3503$var$regionColors = $1i38n$d3scale.scaleOrdinal($1i38n$d3scale.schemeCategory10).range();
const $bc2bf29db86f3503$var$unanchoredColor = "#d3d3d3";
var $bc2bf29db86f3503$var$facets = {
    roots: {
        type: "terms",
        field: "gene_tree_root_taxon_id",
        mincount: 1,
        limit: 100,
        collection: "taxonomy"
    },
    domains: {
        type: "terms",
        field: "domains__ancestors",
        mincount: 1,
        limit: 100
    },
    GO: {
        type: "terms",
        field: "GO__ancestors",
        mincount: 1,
        limit: 100
    },
    pathways: {
        type: "terms",
        field: "pathways__ancestors",
        mincount: 1,
        limit: 100
    }
};
function $bc2bf29db86f3503$var$search(query) {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Search"].genes(query).then((response)=>response.obj));
}
function $bc2bf29db86f3503$var$details(collection, idList) {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Data access"][collection]({
            idList: idList,
            rows: -1
        }).then((response)=>response.obj));
}
function $bc2bf29db86f3503$var$getRegionColors() {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Data access"]["maps"]({
            rows: -1
        }).then((response)=>{
            let colors = {};
            response.obj.forEach((map)=>{
                colors[map.taxon_id] = {};
                for(let i = 0; i < map.regions.names.length; i++)colors[map.taxon_id][map.regions.names[i]] = map.regions.names[i] === "UNANCHORED" ? $bc2bf29db86f3503$var$unanchoredColor : $bc2bf29db86f3503$var$regionColors[i % $bc2bf29db86f3503$var$regionColors.length];
            });
            return colors;
        }));
}
function $bc2bf29db86f3503$var$centralGenePromise(queryString) {
    return $bc2bf29db86f3503$var$search({
        q: queryString,
        rows: 10000,
        start: 0,
        fl: [
            "compara_idx",
            "gene_idx",
            "id",
            "taxon_id",
            "region",
            "start",
            "end",
            "strand"
        ]
    });
}
function $bc2bf29db86f3503$var$allGenesPromise(queryString, numberOfNeighbors) {
    var fieldToQuery = 20;
    if (numberOfNeighbors <= 10) fieldToQuery = 10;
    if (numberOfNeighbors <= 5) fieldToQuery = 5;
    return $bc2bf29db86f3503$var$search({
        fq: `{!graph from=compara_neighbors_${fieldToQuery} to=compara_idx_multi maxDepth=1}${queryString}`,
        rows: 100000,
        start: 0,
        fl: [
            "id",
            "name",
            "compara_idx",
            "gene_idx",
            "gene_tree",
            "taxon_id",
            "system_name",
            "closest_rep*",
            "model_rep*",
            "region",
            "strand",
            "biotype",
            "gene_tree_root_taxon_id",
            "description",
            "start",
            "end",
            "domains__ancestors",
            "GO__ancestors",
            "pathways__ancestors"
        ],
        "json.facet": JSON.stringify($bc2bf29db86f3503$var$facets)
    });
}
function $bc2bf29db86f3503$var$indexGenes(neighborhoodResponse) {
    const genes = {};
    neighborhoodResponse.response.docs.forEach(function(doc) {
        genes[doc.gene_idx] = doc;
    });
    return {
        genes: genes,
        facets: neighborhoodResponse.facets
    };
}
function $bc2bf29db86f3503$var$lookupFacetInfo(neighborhoodResponse) {
    var facetCounts = (0, ($parcel$interopDefault($1i38n$lodash))).cloneDeep($bc2bf29db86f3503$var$facets);
    var detailsPromises = [];
    (0, ($parcel$interopDefault($1i38n$lodash))).forEach(facetCounts, (facetCount, f)=>{
        if (neighborhoodResponse.facets.hasOwnProperty(f)) {
            var idList = [];
            facetCount.counts = neighborhoodResponse.facets[f].buckets.map(function(bucket) {
                idList.push(bucket.val);
                return {
                    id: bucket.val,
                    count: bucket.count
                };
            });
            if (idList.length > 0) {
                var collection = facetCount.hasOwnProperty("collection") ? facetCount.collection : f;
                detailsPromises.push($bc2bf29db86f3503$var$details(collection, idList).then(function(docs) {
                    const details = {};
                    docs.forEach(function(doc) {
                        details[doc._id] = doc;
                    });
                    facetCount.counts.forEach(function(bucket) {
                        bucket.info = details[bucket.id];
                    });
                    return 0;
                }));
            }
        }
    });
    // run all the promises
    return (0, ($parcel$interopDefault($1i38n$q))).all(detailsPromises).then(function() {
        neighborhoodResponse.facets = facetCounts;
        return neighborhoodResponse;
    });
}
function $bc2bf29db86f3503$var$groupGenesIntoNeighborhoods(centralGenes, allGenesAndFacets, color, numberOfNeighbors, sortedIdsAndIdentities) {
    let allGenes = allGenesAndFacets.genes;
    const neighborhoods = [];
    const geneDocs = (0, ($parcel$interopDefault($1i38n$lodash))).keyBy(centralGenes.response.docs, "id");
    let spanDistribution = [];
    sortedIdsAndIdentities.forEach(function(geneIdAndIdentity) {
        const geneId = geneIdAndIdentity.id;
        const doc = geneDocs[geneId];
        if (doc) {
            const geneNeighborhood = {
                region: {
                    name: doc.region,
                    color: color[doc.taxon_id][doc.region] || $bc2bf29db86f3503$var$unanchoredColor
                },
                center_gene_id: doc.id,
                center_relationToGeneOfInterest: geneIdAndIdentity.relationToGeneOfInterest,
                center_idx: 0,
                genes: [] // tbd
            };
            const idx = doc.gene_idx;
            const compara_idx = doc.compara_idx;
            let first = idx - 1;
            while(allGenes[first] && allGenes[first].compara_idx + numberOfNeighbors >= compara_idx)first--;
            let last = idx + 1;
            while(allGenes[last] && allGenes[last].compara_idx - numberOfNeighbors <= compara_idx)last++;
            for(let i = first; i <= last; i++)if (!!allGenes[i] && allGenes[i].taxon_id === allGenes[idx].taxon_id && allGenes[i].region === allGenes[idx].region) {
                if (i === idx) geneNeighborhood.center_idx = geneNeighborhood.genes.length;
                allGenes[i].tree_id = allGenes[i].gene_tree;
                allGenes[i].orientation = allGenes[i].strand === 1 ? "+" : "-";
                geneNeighborhood.genes.push(allGenes[i]);
            }
            geneNeighborhood.region.start = geneNeighborhood.genes[0].start;
            geneNeighborhood.region.end = geneNeighborhood.genes[geneNeighborhood.genes.length - 1].end;
            // non-coding group length histogram
            let spanStart = 0;
            let spanIsNonCoding = false;
            geneNeighborhood.genes.forEach(function(g, i) {
                if (!g.gene_tree) {
                    if (!spanIsNonCoding) {
                        spanStart = i;
                        spanIsNonCoding = true;
                    }
                } else if (spanIsNonCoding) {
                    let offset = i - spanStart;
                    if (spanDistribution[offset]) spanDistribution[offset]++;
                    else spanDistribution[offset] = 1;
                    spanIsNonCoding = false;
                }
            });
            // catch the edge case where the neighborhood ends with non-coding genes
            if (spanIsNonCoding) {
                let offset = geneNeighborhood.genes.length - spanStart;
                if (spanDistribution[offset]) spanDistribution[offset]++;
                else spanDistribution[offset] = 1;
            }
            neighborhoods.push(geneNeighborhood);
        }
    });
    return {
        neighborhoods: neighborhoods,
        facets: allGenesAndFacets.facets,
        nonCodingGroupLengthDistribution: spanDistribution,
        geneDocs: geneDocs
    };
}
function $bc2bf29db86f3503$var$reverseNeigborhoodsIfGeneOfInterestOnNegativeStrand(neighborhoodsAndFacets) {
    let oriented = {};
    let neighborhoods = neighborhoodsAndFacets.neighborhoods.map((neighborhood)=>{
        const { genes: genes, center_idx: center_idx } = neighborhood;
        const centerGenes = genes[center_idx];
        centerGenes.relationToGeneOfInterest = neighborhood.center_relationToGeneOfInterest;
        if (!oriented[centerGenes.id]) {
            if (centerGenes.orientation === "-") {
                // genes.reverse();
                genes.forEach((gene)=>{
                    gene.orientation = gene.orientation === "-" ? "+" : "-";
                });
                // neighborhood.center_idx = (genes.length - 1) - neighborhood.center_idx;
                neighborhood.strand = "reverse";
            } else neighborhood.strand = "forward";
            genes.forEach((gene)=>oriented[gene.id] = neighborhood.strand);
        } else neighborhood.strand = oriented[centerGenes.id];
        return neighborhood;
    });
    neighborhoodsAndFacets.neighborhoods = (0, ($parcel$interopDefault($1i38n$lodash))).keyBy(neighborhoods, "center_gene_id");
    return neighborhoodsAndFacets;
}
function $bc2bf29db86f3503$var$getAndIndexGenes(queryString, numberOfNeighbors) {
    return $bc2bf29db86f3503$var$allGenesPromise(queryString, numberOfNeighbors).then($bc2bf29db86f3503$var$lookupFacetInfo).then($bc2bf29db86f3503$var$indexGenes);
}
function $bc2bf29db86f3503$export$2e2bcd8739ae039(genetree, numberOfNeighbors, genomesOfInterest) {
    let queryString = `gene_tree:${genetree.model._id}`;
    // if (!_.isEmpty(genomesOfInterest)) {
    //   let taxa = Object.keys(genomesOfInterest).join(' ');
    //   queryString = `${queryString} AND taxonomy__ancestors:(${taxa})`;
    // }
    return (0, ($parcel$interopDefault($1i38n$q))).all([
        $bc2bf29db86f3503$var$centralGenePromise(queryString),
        $bc2bf29db86f3503$var$getAndIndexGenes(queryString, numberOfNeighbors),
        $bc2bf29db86f3503$var$getRegionColors(),
        numberOfNeighbors,
        genetree.leafNodes().map((n)=>{
            return {
                id: n.model.gene_stable_id,
                relationToGeneOfInterest: n.relationToGeneOfInterest
            };
        }).sort((a, b)=>b.relationToGeneOfInterest.identity - a.relationToGeneOfInterest.identity)
    ]).spread($bc2bf29db86f3503$var$groupGenesIntoNeighborhoods).then($bc2bf29db86f3503$var$reverseNeigborhoodsIfGeneOfInterestOnNegativeStrand);
}













var $4963a3e9a834b965$export$2e2bcd8739ae039 = {
    LABEL: "label"
};



const $48bcb93d056f01ef$var$style = {
    // border: '1px dashed gray',
    padding: "0.25rem 0.5rem",
    backgroundColor: "white",
    cursor: "move",
    display: "inline-block",
    zoom: 1,
    verticalAlign: "top",
    width: "20%"
};
const $48bcb93d056f01ef$var$labelSource = {
    beginDrag (props) {
        return {
            id: props.id,
            index: props.index
        };
    }
};
const $48bcb93d056f01ef$var$labelTarget = {
    hover (props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) return;
        // Determine rectangle on screen
        const hoverBoundingRect = (0, $1i38n$reactdom.findDOMNode)(component).getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
        // Time to actually perform the action
        props.moveLabel(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};
class $48bcb93d056f01ef$var$Label extends (0, $1i38n$react.Component) {
    render() {
        const { text: text, isDragging: isDragging, connectDragSource: connectDragSource, connectDropTarget: connectDropTarget, checked: checked } = this.props;
        const opacity = isDragging ? 0 : 1;
        return connectDragSource(connectDropTarget(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
            style: {
                ...$48bcb93d056f01ef$var$style,
                opacity: opacity
            },
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                style: {
                    border: "1px dashed gray",
                    padding: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("input", {
                        name: text,
                        onChange: ()=>this.props.toggleLabel(this.props.index),
                        checked: checked,
                        type: "checkbox"
                    }),
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("label", {
                        style: {
                            marginBottom: 0,
                            paddingLeft: "0.2rem"
                        },
                        htmlFor: text,
                        children: text
                    })
                ]
            })
        })));
    }
}
$48bcb93d056f01ef$var$Label.propTypes = {
    connectDragSource: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    connectDropTarget: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    index: (0, ($parcel$interopDefault($1i38n$proptypes))).number.isRequired,
    isDragging: (0, ($parcel$interopDefault($1i38n$proptypes))).bool.isRequired,
    id: (0, ($parcel$interopDefault($1i38n$proptypes))).any.isRequired,
    text: (0, ($parcel$interopDefault($1i38n$proptypes))).string.isRequired,
    moveLabel: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired,
    checked: (0, ($parcel$interopDefault($1i38n$proptypes))).bool.isRequired,
    toggleLabel: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired
};
var $48bcb93d056f01ef$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($1i38n$lodashflow)))((0, $1i38n$reactdnd.DropTarget)((0, $4963a3e9a834b965$export$2e2bcd8739ae039).LABEL, $48bcb93d056f01ef$var$labelTarget, (connect)=>({
        connectDropTarget: connect.dropTarget()
    })), (0, $1i38n$reactdnd.DragSource)((0, $4963a3e9a834b965$export$2e2bcd8739ae039).LABEL, $48bcb93d056f01ef$var$labelSource, (connect, monitor)=>({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    })))($48bcb93d056f01ef$var$Label);





const $4c161799644cf022$var$style = {};
class $4c161799644cf022$var$LabelConfig extends (0, $1i38n$react.Component) {
    constructor(props){
        super(props);
        this.moveLabel = this.moveLabel.bind(this);
        this.state = {
            labels: [
                {
                    id: 1,
                    text: "Species",
                    field: "model.taxon_name",
                    checked: (0, ($parcel$interopDefault($1i38n$lodash))).includes(props.labelFields, "model.taxon_name")
                },
                {
                    id: 2,
                    text: "Gene name",
                    field: "model.gene_display_label",
                    checked: (0, ($parcel$interopDefault($1i38n$lodash))).includes(props.labelFields, "model.gene_display_label")
                },
                {
                    id: 3,
                    text: "Gene ID",
                    field: "model.gene_stable_id",
                    checked: (0, ($parcel$interopDefault($1i38n$lodash))).includes(props.labelFields, "model.gene_stable_id")
                },
                {
                    id: 4,
                    text: "Protein ID",
                    field: "model.protein_stable_id",
                    checked: (0, ($parcel$interopDefault($1i38n$lodash))).includes(props.labelFields, "model.protein_stable_id")
                }
            ]
        };
    }
    componentDidUpdate(prevProps, prevState) {
        const x = this.state.labels.filter((l)=>l.checked).map((l)=>l.field);
        const y = prevState.labels.filter((l)=>l.checked).map((l)=>l.field);
        if (!(0, ($parcel$interopDefault($1i38n$lodash))).isEqual(x, y)) this.props.updateLabelFields(x);
    }
    moveLabel(dragIndex, hoverIndex) {
        const { labels: labels } = this.state;
        const dragLabel = labels[dragIndex];
        this.setState((0, ($parcel$interopDefault($1i38n$immutabilityhelper)))(this.state, {
            labels: {
                $splice: [
                    [
                        dragIndex,
                        1
                    ],
                    [
                        hoverIndex,
                        0,
                        dragLabel
                    ]
                ]
            }
        }));
    }
    toggleLabel(index) {
        let labels = (0, ($parcel$interopDefault($1i38n$lodash))).cloneDeep(this.state.labels);
        let label = labels[index];
        label.checked = !label.checked;
        this.setState({
            labels: labels
        });
    }
    render() {
        const { labels: labels } = this.state;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            style: $4c161799644cf022$var$style,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    children: "drag to reorder"
                }),
                labels.map((label, i)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $48bcb93d056f01ef$export$2e2bcd8739ae039), {
                        index: i,
                        id: label.id,
                        checked: label.checked,
                        text: label.text,
                        moveLabel: this.moveLabel,
                        toggleLabel: this.toggleLabel.bind(this)
                    }, label.id))
            ]
        });
    }
}
$4c161799644cf022$var$LabelConfig.propTypes = {
    labelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).array.isRequired,
    updateLabelFields: (0, ($parcel$interopDefault($1i38n$proptypes))).func.isRequired
};
var $4c161799644cf022$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($1i38n$lodashflow)))((0, $1i38n$reactdnd.DragDropContext)((0, ($parcel$interopDefault($1i38n$reactdndhtml5backend)))))($4c161799644cf022$var$LabelConfig);


let $d92d39518efdc8e9$var$pruneTree = (0, ($parcel$interopDefault($1i38n$gramenetreesclient))).extensions.pruneTree;
let $d92d39518efdc8e9$var$addConsensus = (0, ($parcel$interopDefault($1i38n$gramenetreesclient))).extensions.addConsensus;
const $d92d39518efdc8e9$var$DEFAULT_MARGIN = 20;
const $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT = 20;
const $d92d39518efdc8e9$var$DEFAULT_LABEL_WIDTH = 200;
const $d92d39518efdc8e9$var$CURATION_WIDTH = 200;
const $d92d39518efdc8e9$var$MIN_TREE_WIDTH = 50;
const $d92d39518efdc8e9$var$MAX_TREE_WIDTH = 200;
const $d92d39518efdc8e9$var$MIN_VIZ_WIDTH = 150;
const $d92d39518efdc8e9$var$windowResizeDebounceMs = 250;
const $d92d39518efdc8e9$var$rangeChangeDebounceMs = 150;
const $d92d39518efdc8e9$var$localStore = $parcel$global.localStorage || {};
function $d92d39518efdc8e9$var$getLabelFields() {
    let labelFields = $d92d39518efdc8e9$var$localStore.getItem("genetreeLeafLabels");
    if (labelFields) return JSON.parse(labelFields);
    else return [
        "model.gene_stable_id"
    ];
}
class $d92d39518efdc8e9$var$TreeVis extends (0, ($parcel$interopDefault($1i38n$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            geneOfInterest: this.props.initialGeneOfInterest,
            displayMode: "domains",
            visibleNodes: undefined,
            colorScheme: "clustal",
            configModal: false,
            labelFields: $d92d39518efdc8e9$var$getLabelFields(),
            MSARange: {
                MSAStart: 0,
                MSAStop: 0
            }
        };
        this.displayModes = [
            {
                id: "domains",
                label: "Alignment overview",
                description: "Proteins color-coded by InterPro domain. Resize slider to navigate.",
                getComponent: function(app) {
                    if (app.geneTreeRoot && app.state.visibleNodes && app.vizWidth && app.domainStats) return /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createElement((0, $2dbe1a8664116125$export$2e2bcd8739ae039), {
                        nodes: app.state.visibleNodes,
                        rootNode: app.geneTreeRoot,
                        width: app.vizWidth,
                        height: app.treeHeight,
                        margin: app.margin,
                        xOffset: app.margin + app.treeWidth + app.labelWidth,
                        yOffset: 0,
                        controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        stats: app.domainStats,
                        MSARange: app.state.MSARange,
                        handleRangeChange: (0, ($parcel$interopDefault($1i38n$lodash))).debounce(app.updateMSARange.bind(app), $d92d39518efdc8e9$var$rangeChangeDebounceMs),
                        transform: app.transformViz
                    });
                }
            },
            {
                id: "msa",
                label: "Multiple Sequence Alignment",
                description: "Amino acid MSA. Drag slider to reposition.",
                getComponent: function(app) {
                    if (app.geneTreeRoot && app.state.visibleNodes && app.vizWidth && app.domainStats) return /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createElement((0, $3a89ac38d37e6c49$export$2e2bcd8739ae039), {
                        nodes: app.state.visibleNodes,
                        rootNode: app.geneTreeRoot,
                        width: app.vizWidth,
                        height: app.treeHeight,
                        margin: app.margin,
                        xOffset: app.margin + app.treeWidth + app.labelWidth,
                        yOffset: 0,
                        controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        stats: app.domainStats,
                        colorScheme: app.state.colorScheme,
                        MSARange: app.state.MSARange,
                        handleRangeChange: (0, ($parcel$interopDefault($1i38n$lodash))).debounce(app.updateMSARange.bind(app), $d92d39518efdc8e9$var$rangeChangeDebounceMs),
                        transform: app.transformViz
                    });
                }
            }
        ];
        if (this.props.enablePhyloview) this.displayModes.push({
            id: "phyloview",
            label: "Neighborhood conservation",
            description: "+/- 10 genes flanking the gene of interest (top row) are color-coded by gene family. Gray genes are from other families. Central genes (green) are shaded based on similarity with gene of interest.",
            getComponent: function(app) {
                if (app.state.visibleNodes && app.state.neighborhoods && app.vizWidth) return /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createElement((0, $86f31c7466377268$export$2e2bcd8739ae039), {
                    nodes: app.state.visibleNodes,
                    queryNode: app.genetree.indices.gene_stable_id[app.state.geneOfInterest._id],
                    width: app.vizWidth,
                    height: app.treeHeight,
                    margin: app.margin,
                    xOffset: app.margin + app.treeWidth + app.labelWidth,
                    yOffset: 0,
                    controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                    neighborhoods: app.state.neighborhoods,
                    maxNCGGenes: app.state.nonCodingGroupLengthDistribution.length - 1,
                    numberOfNeighbors: app.props.numberOfNeighbors,
                    transform: app.transformViz,
                    ensemblUrl: app.props.ensemblUrl
                });
            }
        });
        this.displayModeIdx = (0, ($parcel$interopDefault($1i38n$lodash))).keyBy(this.displayModes, "id");
    }
    updateMSARange(MSARange) {
        this.setState(MSARange);
    }
    componentDidMount() {
        this.resizeListener = (0, ($parcel$interopDefault($1i38n$lodash))).debounce(this.updateAvailableWidth.bind(this), $d92d39518efdc8e9$var$windowResizeDebounceMs);
        if (!(0, ($parcel$interopDefault($1i38n$lodash))).isUndefined($parcel$global.addEventListener)) $parcel$global.addEventListener("resize", this.resizeListener);
        this.domainStats = (0, $aed637ffd5f869a8$export$2e2bcd8739ae039)(this.props.genetree); // TODO: use a promise and a web worker
        if (!(0, ($parcel$interopDefault($1i38n$lodash))).isEmpty(this.props.genomesOfInterest)) {
            this.genetree = $d92d39518efdc8e9$var$pruneTree(this.props.genetree, (function(node) {
                return this.props.genomesOfInterest.hasOwnProperty(node.model.taxon_id);
            }).bind(this));
            this.genetree.geneCount = this.props.genetree.geneCount;
        } else this.genetree = (0, ($parcel$interopDefault($1i38n$lodash))).cloneDeep(this.props.genetree);
        (0, $f295311ee73679ba$export$e2f5f157c8e85aef)(this.genetree);
        $d92d39518efdc8e9$var$addConsensus(this.genetree); // TODO: use a promise
        (0, $8c542044289fc59b$export$2e2bcd8739ae039)(this.genetree, this.props.initialGeneOfInterest, this.props.taxonomy, this.props.pivotTree);
        if (this.props.enableCuration) {
            (0, $f295311ee73679ba$export$6ec9a7cb49676029)(this.genetree, this.props.initialGeneOfInterest, false);
            let curatable = this.props.curatable;
            const goi_tax = this.props.initialGeneOfInterest.taxon_id;
            this.genetree.walk(function(node) {
                if (curatable.hasOwnProperty("all") && node.model.cigar || curatable.hasOwnProperty(node.model.taxon_id)) {
                    let parentNode = node.parent;
                    while(!parentNode.displayInfo.expanded){
                        parentNode.displayInfo.expanded = true;
                        parentNode.displayInfo.expandedCuratable = true;
                        parentNode = parentNode.parent;
                    }
                }
            });
        } else (0, $f295311ee73679ba$export$6ec9a7cb49676029)(this.genetree, this.props.initialGeneOfInterest, true);
        // if (this.props.enableCuration && this.genetree.displayInfo.paralogs) {
        //   let node = this.genetree;
        //   node.displayInfo.paralogs.forEach(function (paralog) {
        //     let parentNode = paralog.parent;
        //     while (!parentNode.displayInfo.expanded) {
        //       parentNode.displayInfo.expanded = true;
        //       parentNode.displayInfo.expandedParalogs = true;
        //       parentNode = parentNode.parent
        //     }
        //   });
        // }
        (0, $f295311ee73679ba$export$cbecd1a31826c595)(this.genetree);
        this.treeHeight = (0, $f7e47e6ef7e802bb$export$2e2bcd8739ae039)(this.genetree);
        this.geneTreeRoot = (0, ($parcel$interopDefault($1i38n$lodash))).clone(this.genetree);
        delete this.geneTreeRoot.displayInfo;
        this.geneTreeRoot.displayInfo = {
            expanded: false
        };
        let MSARange = this.state.MSARange;
        MSARange.MSAStop = this.geneTreeRoot.model.consensus.sequence.length;
        this.setState(MSARange);
        (0, $f295311ee73679ba$export$cbecd1a31826c595)(this.geneTreeRoot);
        (0, $1ec57391cf50db74$export$2e2bcd8739ae039)(this.geneTreeRoot, 0, this.treeHeight);
        //let ma = alignmentTools.calculateAlignment(this.genetree);
        //if (!_.isEmpty(this.props.genomesOfInterest)) {
        //  let gaps = alignmentTools.findGaps(ma);
        //  alignmentTools.removeGaps(gaps, this.genetree);
        //}
        this.domainHist = (0, $5ac4cd4b588bde41$export$2e2bcd8739ae039)(this.genetree, true);
        if (this.props.enablePhyloview) {
            let that = this;
            (0, $bc2bf29db86f3503$export$2e2bcd8739ae039)(this.genetree, this.props.numberOfNeighbors, this.props.genomesOfInterest).then(function(neighborhoodsAndFacets) {
                that.setState(neighborhoodsAndFacets);
            });
        }
        this.updateAvailableWidth();
    }
    componentWillUnmount() {
        if (this.resizeListener) $parcel$global.removeEventListener("resize", this.resizeListener);
    }
    updateAvailableWidth() {
        const DOMNode = (0, ($parcel$interopDefault($1i38n$reactdom))).findDOMNode(this);
        const parentWidth = DOMNode.parentNode ? DOMNode.parentNode.clientWidth : DOMNode.clientWidth;
        if (this.width !== parentWidth) {
            this.width = parentWidth;
            this.initHeightAndMargin();
            this.setState({
                visibleNodes: (0, $1ec57391cf50db74$export$2e2bcd8739ae039)(this.genetree, this.treeWidth, this.treeHeight)
            });
        }
    }
    initHeightAndMargin() {
        this.margin = this.props.margin || $d92d39518efdc8e9$var$DEFAULT_MARGIN;
        this.labelWidth = this.props.labelWidth || $d92d39518efdc8e9$var$DEFAULT_LABEL_WIDTH;
        const w = this.width - this.labelWidth - 2 * this.margin;
        this.treeWidth = .25 * w < $d92d39518efdc8e9$var$MIN_TREE_WIDTH ? $d92d39518efdc8e9$var$MIN_TREE_WIDTH : Math.floor(.25 * w);
        if (this.treeWidth > $d92d39518efdc8e9$var$MAX_TREE_WIDTH) this.treeWidth = $d92d39518efdc8e9$var$MAX_TREE_WIDTH;
        this.vizWidth = w - this.treeWidth < $d92d39518efdc8e9$var$MIN_VIZ_WIDTH ? $d92d39518efdc8e9$var$MIN_VIZ_WIDTH : w - this.treeWidth;
        if (this.treeWidth + this.vizWidth + this.labelWidth + 2 * this.margin > this.width) {
            console.log("Is this too small to see everything?");
            this.width = this.treeWidth + this.vizWidth + this.labelWidth + 2 * this.margin;
        }
        if (this.props.enableCuration) this.vizWidth -= $d92d39518efdc8e9$var$CURATION_WIDTH;
        this.transformTree = `translate(${this.margin},${this.margin + $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT})`;
        this.transformViz = `translate(${this.margin + this.treeWidth + this.labelWidth},0)`;
    }
    handleGeneSelect(geneNode) {
        (0, $1i38n$gramenesearchclient.client).genes(geneNode.model.gene_stable_id).then((function(response) {
            let geneOfInterest = response.docs[0];
            (0, $8c542044289fc59b$export$2e2bcd8739ae039)(this.genetree, geneOfInterest, this.props.taxonomy, this.props.pivotTree);
            (0, $f295311ee73679ba$export$6ec9a7cb49676029)(this.genetree, geneOfInterest, true);
            (0, $f295311ee73679ba$export$cbecd1a31826c595)(this.genetree);
            this.treeHeight = (0, $f7e47e6ef7e802bb$export$2e2bcd8739ae039)(this.genetree);
            let visibleNodes = (0, $1ec57391cf50db74$export$2e2bcd8739ae039)(this.genetree, this.treeWidth, this.treeHeight);
            this.setState({
                geneOfInterest: geneOfInterest,
                visibleNodes: visibleNodes
            });
        }).bind(this));
    }
    expandClade(node, recursive) {
        if (recursive) (0, $f295311ee73679ba$export$d865796a5b4a7f49)(node);
        else (0, $f295311ee73679ba$export$8b60bd6775d46208)(node);
        this.updateVisibleNodes();
    }
    collapseClade(node, recursive) {
        if (recursive) (0, $f295311ee73679ba$export$5be4099be9306efa)(node);
        else (0, $f295311ee73679ba$export$3e625f118b045824)(node);
        this.updateVisibleNodes();
    }
    updateVisibleNodes() {
        (0, $f295311ee73679ba$export$cbecd1a31826c595)(this.genetree);
        this.treeHeight = (0, $f7e47e6ef7e802bb$export$2e2bcd8739ae039)(this.genetree);
        const newVisibleNodes = (0, $1ec57391cf50db74$export$2e2bcd8739ae039)(this.genetree, this.treeWidth, this.treeHeight);
        this.setState({
            visibleNodes: newVisibleNodes
        });
    }
    handleNodeUnhover(node) {
        if (this.state.hoveredNode === node) this.setState({
            hoveredNode: undefined
        });
    }
    handleNodeHover(node) {
        this.setState({
            hoveredNode: node
        });
    }
    changeParalogVisibility(node) {
        if (node.displayInfo.paralogs) {
            if (node.displayInfo.expandedParalogs) // hide these paralogs
            node.displayInfo.paralogs.forEach(function(paralog) {
                let parentNode = paralog.parent;
                const childCallback = (child)=>{
                    if (child.displayInfo.expanded) parentNode.displayInfo.expanded = true;
                };
                while(parentNode !== node){
                    parentNode.displayInfo.expandedParalogs = false;
                    // check if any child is expanded
                    parentNode.displayInfo.expanded = false;
                    parentNode.children.forEach(childCallback);
                    parentNode = parentNode.parent;
                }
            });
            else node.displayInfo.paralogs.forEach(function(paralog) {
                let parentNode = paralog.parent;
                while(!parentNode.displayInfo.expanded){
                    parentNode.displayInfo.expanded = true;
                    parentNode.displayInfo.expandedParalogs = true;
                    parentNode = parentNode.parent;
                }
            });
            this.updateVisibleNodes();
        }
    }
    toggleConfigModal() {
        this.setState({
            configModal: !this.state.configModal
        });
    }
    handleModeSelection(e) {
        this.setState({
            displayMode: e
        });
    }
    colorSchemeDropdown() {
        // if (this.state.displayMode === 'msa') {
        function toTitleCase(str) {
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
        const colorSchemes = [
            "clustal",
            "zappo",
            "taylor",
            "hydrophobicity",
            "helix_propensity",
            "strand_propensity",
            "turn_propensity",
            "buried_index"
        ];
        let items = colorSchemes.map((function(scheme, i) {
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Dropdown).Item, {
                eventKey: i,
                active: scheme === this.state.colorScheme,
                onClick: ()=>this.setState({
                        colorScheme: scheme
                    }),
                children: toTitleCase(scheme.replace("_", " "))
            }, i);
        }).bind(this));
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.DropdownButton), {
            id: "colorscheme-dropdown",
            title: "Color Scheme",
            disabled: this.state.displayMode !== "msa",
            variant: "outline-dark",
            size: "sm",
            children: items
        });
    // }
    }
    renderToolbar(activeMode) {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            className: "display-mode",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.ButtonToolbar), {
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Button), {
                            onClick: ()=>this.toggleConfigModal(),
                            variant: "light",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reacticonsbs.BsGearFill), {})
                        }),
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.DropdownButton), {
                            id: "displaymode-dropdown",
                            title: "Display Mode",
                            variant: "outline-dark",
                            size: "sm",
                            children: this.displayModes.map((mode, idx)=>{
                                return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Dropdown).Item, {
                                    eventKey: mode.id,
                                    active: activeMode === mode.id,
                                    onClick: ()=>this.setState({
                                            displayMode: mode.id
                                        }),
                                    children: mode.label
                                }, idx);
                            })
                        }),
                        this.colorSchemeDropdown()
                    ]
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("span", {
                    style: {
                        "marginLeft": `${this.margin + this.treeWidth + this.labelWidth}px`,
                        float: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("b", {
                            children: [
                                this.displayModeIdx[activeMode].label,
                                ": "
                            ]
                        }),
                        this.displayModeIdx[activeMode].description
                    ]
                }),
                this.props.enableCuration && /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                    style: {
                        position: "absolute",
                        left: `${this.margin + this.treeWidth + this.labelWidth + this.vizWidth}px`
                    },
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("b", {
                            children: "Curate"
                        }),
                        ": click to flag genes",
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                            children: [
                                "\xa0",
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                    className: "curation okay",
                                    children: "okay"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                    className: "curation unclear",
                                    children: "flag"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    updateLabelConfig(labelFields) {
        if (!(0, ($parcel$interopDefault($1i38n$lodash))).isEqual(labelFields, this.state.labelFields)) {
            $d92d39518efdc8e9$var$localStore.setItem("genetreeLeafLabels", JSON.stringify(labelFields));
            this.setState({
                labelFields: labelFields
            });
        }
    }
    render() {
        if (!(this.state.visibleNodes && this.state.geneDocs)) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {});
        let genetree = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $42eda629c119b935$export$2e2bcd8739ae039), {
            nodes: this.state.visibleNodes,
            labelFields: this.state.labelFields,
            onGeneSelect: this.handleGeneSelect.bind(this),
            collapseClade: this.collapseClade.bind(this),
            expandClade: this.expandClade.bind(this),
            changeParalogVisibility: this.changeParalogVisibility.bind(this),
            onNodeHover: this.handleNodeHover,
            onNodeUnhover: this.handleNodeUnhover,
            taxonomy: this.props.taxonomy,
            geneDocs: this.state.geneDocs
        });
        let theViz = this.displayModeIdx[this.state.displayMode].getComponent(this);
        if (!theViz) theViz = /*#__PURE__*/ (0, ($parcel$interopDefault($1i38n$react))).createElement((0, $1f9b52c72af6ed55$export$2e2bcd8739ae039), {
            xOffset: this.margin + this.treeWidth + this.labelWidth + this.vizWidth / 2 - 200,
            yOffset: this.treeHeight / 2
        });
        let curation;
        if (this.props.enableCuration) curation = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $d4db98f04dcc88a8$export$2e2bcd8739ae039), {
            nodes: this.state.visibleNodes,
            width: $d92d39518efdc8e9$var$CURATION_WIDTH,
            height: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
            curatable: this.props.curatable,
            xOffset: this.margin + this.treeWidth + this.labelWidth + this.vizWidth,
            yOffset: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT + this.margin - 10,
            getCuration: this.props.getCuration
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                this.renderToolbar(this.state.displayMode),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)((0, $1i38n$reactbootstrap.Modal), {
                    show: this.state.configModal,
                    onHide: this.toggleConfigModal.bind(this),
                    size: "lg",
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Modal).Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Modal).Title, {
                                children: "Configure labels"
                            })
                        }),
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $1i38n$reactbootstrap.Modal).Body, {
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)((0, $4c161799644cf022$export$2e2bcd8739ae039), {
                                labelFields: this.state.labelFields,
                                updateLabelFields: (l)=>this.updateLabelConfig(l)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "genetree-vis",
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("svg", {
                        width: this.width,
                        height: this.treeHeight + 2 * this.margin + $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                                className: "tree-wrapper",
                                transform: this.transformTree,
                                children: genetree
                            }),
                            theViz,
                            curation
                        ]
                    })
                })
            ]
        });
    }
}
$d92d39518efdc8e9$var$TreeVis.propTypes = {
    margin: (0, ($parcel$interopDefault($1i38n$proptypes))).number,
    genetree: (0, ($parcel$interopDefault($1i38n$proptypes))).object.isRequired,
    initialGeneOfInterest: (0, ($parcel$interopDefault($1i38n$proptypes))).object,
    genomesOfInterest: (0, ($parcel$interopDefault($1i38n$proptypes))).object,
    taxonomy: (0, ($parcel$interopDefault($1i38n$proptypes))).object,
    pivotTree: (0, ($parcel$interopDefault($1i38n$proptypes))).bool,
    numberOfNeighbors: (0, ($parcel$interopDefault($1i38n$proptypes))).number,
    enablePhyloview: (0, ($parcel$interopDefault($1i38n$proptypes))).bool,
    ensemblUrl: (0, ($parcel$interopDefault($1i38n$proptypes))).string.isRequired
};
var $d92d39518efdc8e9$export$2e2bcd8739ae039 = $d92d39518efdc8e9$var$TreeVis;


//# sourceMappingURL=index.js.map
